"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[643],{

/***/ 4675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export DisplayAbove */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  ",
        " {\n    display: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var DisplayAbove = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-921e81d2-0"
})(_templateObject(), function(param) {
    var theme = param.theme, breakpoint = param.breakpoint;
    var ref;
    return (ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref[breakpoint];
}, function(param) {
    var display = param.display;
    return display !== null && display !== void 0 ? display : "block";
});
/* harmony default export */ __webpack_exports__["Z"] = (DisplayAbove);


/***/ }),

/***/ 1138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export DisplayBelow */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var DisplayBelow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-1c97c667-0"
})(_templateObject(), function(param) {
    var display = param.display;
    return display !== null && display !== void 0 ? display : "block";
}, function(param) {
    var theme = param.theme, breakpoint = param.breakpoint;
    var ref;
    return (ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref[breakpoint];
});
/* harmony default export */ __webpack_exports__["Z"] = (DisplayBelow);


/***/ }),

/***/ 5580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export InputText */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: var(--font-family-sans-serif);\n  border: 1px solid #000;\n  background: #fff;\n  position: relative;\n  appearance: none;\n  width: 100%;\n  border-radius: 0;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n\n  &::placeholder {\n    font-family: var(--font-family-sans-serif);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var InputText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-c048e94e-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (InputText);


/***/ }),

/***/ 9643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ map_Layout; }
});

// UNUSED EXPORTS: Layout

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next-head-seo/dist/index.module.js
var index_module = __webpack_require__(4058);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./providers/ConfigContextProvider.tsx
var ConfigContextProvider = __webpack_require__(5547);
// EXTERNAL MODULE: ./components/app/Menu.tsx
var Menu = __webpack_require__(240);
// EXTERNAL MODULE: ./components/app/MatomoUserTracking.tsx
var MatomoUserTracking = __webpack_require__(7051);
// EXTERNAL MODULE: ./components/styled/LoadingBar.tsx
var LoadingBar = __webpack_require__(4321);
// EXTERNAL MODULE: ./components/app/MenuButton.tsx
var MenuButton = __webpack_require__(3063);
// EXTERNAL MODULE: ./components/tools/shared/Sidebar.tsx + 1 modules
var Sidebar = __webpack_require__(9814);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/tools/shared/ToolSvgBackground.tsx + 40 modules
var ToolSvgBackground = __webpack_require__(7626);
// EXTERNAL MODULE: ./components/tools/shared/ui/Icon.tsx
var Icon = __webpack_require__(7205);
// EXTERNAL MODULE: ./components/tools/map/state/ToolState.tsx
var ToolState = __webpack_require__(8656);
// EXTERNAL MODULE: ./components/tools/map/map/utils.ts
var utils = __webpack_require__(255);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/state/CssVarsState.tsx
var CssVarsState = __webpack_require__(9479);
;// CONCATENATED MODULE: ./components/tools/map/Submenu.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #0008;\n\n  ",
        " {\n    padding: ",
        " 0;\n  }\n\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-3);\n\n  & .subMenuItem {\n    ",
        ";\n    font-size: 1em;\n    white-space: break-spaces;\n    width: min-content;\n    min-width: 100%;\n    line-height: 1.3em;\n    text-align: left;\n    color: white;\n    display: flex;\n    gap: var(--size-3);\n\n    .svg {\n      font-size: 0.5em;\n    }\n\n    ",
        " {\n      font-size: 0.5em;\n      text-align: center;\n      display: block;\n      gap: 0;\n\n      .svg {\n        font-size: 1em;\n        margin: 0 auto var(--size-1);\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: flex;\n  }\n\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  padding: ",
        " 0 var(--size-1);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var sidebarPadding = "var(--size-3)";
var ToolSubmenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9143c6d8-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, sidebarPadding, function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var ActionItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9143c6d8-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, sidebarPadding, sidebarPadding);
var Submenu = function(param) {
    var tool = param.tool, slug = param.slug;
    var router = (0,next_router.useRouter)();
    var filterState = (0,ToolState/* useToolStateFilterState */.QL)();
    var updateFilterState = (0,ToolState/* useToolStateStoreActions */.cH)().updateFilterState;
    var isTabletLandscapeAndUp = (0,CssVarsState/* useCssVarsStateIsTabletLandscapeAndUpState */.Xb)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToolSubmenu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        href: "/tool/map",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "subMenuItem",
                            onClick: function(e) {
                                e.preventDefault();
                                updateFilterState({
                                    isFilterOpen: isTabletLandscapeAndUp,
                                    isSearchOpen: false,
                                    countries: {},
                                    regions: {},
                                    quickViewProjectId: null
                                });
                                router.push({
                                    pathname: "/tool/map",
                                    search: (0,utils/* createQueryFromState */.fy)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), {
                                        countries: {},
                                        regions: {},
                                        isFilterOpen: true,
                                        isSearchOpen: false
                                    }), null, [
                                        "filter",
                                        "search",
                                        "keyword",
                                        "empty"
                                    ])
                                }, undefined, {
                                    shallow: true
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolSvgBackground/* ToolSvgBackground */.V, {
                                    className: "svg icon",
                                    type: "map",
                                    position: "left center",
                                    height: "2em",
                                    width: "2em"
                                }),
                                "Map view"
                            ]
                        })
                    }),
                    slug === "index" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionItems, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                type: "filter",
                                active: (0,utils/* createCompareQueryFromState */.zu)(filterState) !== "",
                                nonMuted: filterState.isFilterOpen,
                                onClick: function() {
                                    var newState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), {
                                        isSearchOpen: false,
                                        keyword: "",
                                        isFilterOpen: !filterState.isFilterOpen
                                    });
                                    updateFilterState(newState);
                                    router.push({
                                        pathname: "/tool/map",
                                        search: (0,utils/* createQueryFromState */.fy)(newState, null, [
                                            "search",
                                            "keyword",
                                            "empty", 
                                        ])
                                    }, undefined, {
                                        shallow: true
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                type: "search",
                                nonMuted: filterState.isSearchOpen,
                                onClick: function() {
                                    updateFilterState({
                                        isSearchOpen: !filterState.isSearchOpen,
                                        isFilterOpen: false,
                                        keyword: ""
                                    });
                                    router.push({
                                        pathname: "/tool/map",
                                        search: "?search=".concat(!filterState.isSearchOpen ? 1 : 0, "&keyword=")
                                    }, undefined, {
                                        shallow: true
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "actionItems",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        href: "/tool/map/directory",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "subMenuItem",
                            onClick: function(e) {
                                e.preventDefault();
                                updateFilterState({
                                    isFilterOpen: isTabletLandscapeAndUp,
                                    isSearchOpen: false,
                                    keyword: "",
                                    quickViewProjectId: null
                                });
                                router.push({
                                    pathname: "/tool/map/directory",
                                    search: (0,utils/* createQueryFromState */.fy)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), {
                                        isFilterOpen: true,
                                        isSearchOpen: false
                                    }), null, [
                                        "filter",
                                        "search",
                                        "keyword",
                                        "empty"
                                    ])
                                }, undefined, {
                                    shallow: true
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolSvgBackground/* ToolSvgBackground */.V, {
                                    className: "svg icon",
                                    type: "list",
                                    position: "left center",
                                    height: "2em",
                                    width: "2em"
                                }),
                                "Directory"
                            ]
                        })
                    }),
                    slug === "directory" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionItems, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                type: "filter",
                                nonMuted: filterState.isFilterOpen,
                                active: (0,utils/* createCompareQueryFromState */.zu)(filterState) !== "",
                                onClick: function() {
                                    var newState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), {
                                        isSearchOpen: false,
                                        keyword: "",
                                        isFilterOpen: !filterState.isFilterOpen
                                    });
                                    updateFilterState(newState);
                                    router.push({
                                        pathname: "/tool/map/directory",
                                        search: (0,utils/* createQueryFromState */.fy)(newState, null, [
                                            "search",
                                            "keyword",
                                            "empty", 
                                        ])
                                    }, undefined, {
                                        shallow: true
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                type: "search",
                                nonMuted: filterState.isSearchOpen,
                                onClick: function() {
                                    updateFilterState({
                                        isFilterOpen: false,
                                        isSearchOpen: !filterState.isSearchOpen,
                                        keyword: ""
                                    });
                                    router.push({
                                        pathname: "/tool/map/directory",
                                        search: "?search=".concat(!filterState.isSearchOpen ? 1 : 0, "&keyword=")
                                    }, undefined, {
                                        shallow: true
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    passHref: true,
                    href: "/tool/map/about",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "subMenuItem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolSvgBackground/* ToolSvgBackground */.V, {
                                className: "svg icon",
                                type: "info",
                                position: "center center",
                                height: "2em",
                                width: "2em"
                            }),
                            "About"
                        ]
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/queryClient.mjs + 7 modules
var queryClient = __webpack_require__(526);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(5945);
;// CONCATENATED MODULE: ./components/tools/map/context/ReactQueryContextProvider.tsx



var ReactQueryContextProvider_queryClient = new queryClient/* QueryClient */.S();
var ReactQueryContextProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryClientProvider/* QueryClientProvider */.aH, {
        client: ReactQueryContextProvider_queryClient,
        children: children
    });
};
/* harmony default export */ var context_ReactQueryContextProvider = (ReactQueryContextProvider);

;// CONCATENATED MODULE: ./components/tools/map/Counter.tsx

function Counter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: white;\n  border-radius: var(--size-3);\n  border: 1px solid\n    ",
        ";\n  // width: calc(100vw - (2 * var(--size-4)));\n\n  pointer-events: all;\n  position: fixed;\n  z-index: 6;\n  bottom: calc(2 * var(--size-3));\n  top: unset;\n  height: var(--size-6);\n  left: 50%;\n  transform: translateX(-50%);\n\n  // justify-items: center;\n  display: flex;\n  flex-direction: row;\n\n  & > * {\n    padding: 0 var(--size-3);\n    border-right: 1px solid #0000001a;\n\n    &:last-child {\n      border-right: none;\n    }\n    margin: auto 0;\n  }\n\n  .label {\n    margin-right: var(--size-2);\n  }\n\n  ",
        " {\n    left: 50%;\n    transform: translateX(-50%);\n    max-width: 500px;\n    width: auto;\n    height: var(--size-5);\n  }\n\n  ",
        " {\n    top: var(--size-3);\n    bottom: unset;\n  }\n\n  ",
        "\n"
    ]);
    Counter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Counter_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: var(--size-1);\n  flex-direction: row;\n\n  // ",
        " {\n  //   flex-direction: row;\n  //   gap: var(--size-1);\n  // }\n\n  span {\n    white-space: nowrap;\n  }\n"
    ]);
    Counter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var CounterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a6cf183-0"
})(Counter_templateObject(), function(param) {
    var theme = param.theme, invert = param.invert;
    return invert ? "#fff2" : theme.color("piaiMap", 0.9);
}, function(param) {
    var invert = param.invert;
    return invert ? "var(--color-grey)" : "var(--color-piai-map)";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("noPrint");
});
var StyledLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a6cf183-1"
})(Counter_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var Label = function(param) {
    var label = param.label, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLabel, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    });
};
var Counter = function(param) {
    var view = param.view;
    var router = (0,next_router.useRouter)();
    var isTabletLandscapeAndUp = (0,CssVarsState/* useCssVarsStateIsTabletLandscapeAndUpState */.Xb)();
    var mapState = (0,ToolState/* useToolStateMapState */.e1)();
    var filterState = (0,ToolState/* useToolStateFilterState */.QL)();
    var updateFilterState = (0,ToolState/* useToolStateStoreActions */.cH)().updateFilterState;
    if (view === "directory" && isTabletLandscapeAndUp) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var onClickFilter = function() {
        updateFilterState({
            isFilterOpen: !filterState.isFilterOpen,
            isSearchOpen: false
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CounterContainer, {
        invert: (filterState.isFilterOpen || filterState.isSearchOpen) && !isTabletLandscapeAndUp,
        children: [
            !isTabletLandscapeAndUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                type: "filter",
                onClick: onClickFilter
            }),
            view === "map" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inView",
                onClick: !isTabletLandscapeAndUp ? onClickFilter : undefined,
                style: {
                    cursor: !isTabletLandscapeAndUp ? "pointer" : "default"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                    label: isTabletLandscapeAndUp ? "Projects in view" : "In view",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: mapState.filteredInViewCount
                        }),
                        "/",
                        mapState.totalInViewCount
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "total",
                onClick: !isTabletLandscapeAndUp ? onClickFilter : undefined,
                style: {
                    cursor: !isTabletLandscapeAndUp ? "pointer" : "default"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                    label: isTabletLandscapeAndUp ? "Projects total" : "Total",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: filterState.filteredCount
                        }),
                        "/",
                        filterState.totalCount
                    ]
                })
            }),
            isTabletLandscapeAndUp ? view === "map" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                type: "list",
                onClick: function() {
                    if (typeof document === "undefined") return;
                    updateFilterState({
                        quickViewProjectId: null
                    });
                    router.push({
                        pathname: "/tool/map/directory",
                        search: document.location.search
                    });
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                type: "map",
                onClick: function() {
                    if (typeof document === "undefined") return;
                    router.push({
                        pathname: "/tool/map",
                        search: document.location.search
                    });
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                type: "search",
                onClick: function() {
                    updateFilterState({
                        isFilterOpen: false,
                        isSearchOpen: !filterState.isSearchOpen
                    });
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/styled/DisplayAbove.tsx
var DisplayAbove = __webpack_require__(4675);
// EXTERNAL MODULE: ./components/styled/DisplayBelow.tsx
var DisplayBelow = __webpack_require__(1138);
// EXTERNAL MODULE: ./components/tools/map/Styled.tsx
var Styled = __webpack_require__(503);
;// CONCATENATED MODULE: ./hooks/useModal.tsx

var useModal = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _defaultIsOpen = ref.defaultIsOpen, defaultIsOpen = _defaultIsOpen === void 0 ? false : _defaultIsOpen, _openingAnimationLength = ref.openingAnimationLength, openingAnimationLength = _openingAnimationLength === void 0 ? 500 : _openingAnimationLength, _closeAnimationLength = ref.closeAnimationLength, closeAnimationLength = _closeAnimationLength === void 0 ? 250 : _closeAnimationLength;
    var isAnimatingTimeoutRef = (0,react.useRef)(null);
    var isOpenRef = (0,react.useRef)(defaultIsOpen);
    var isOpeningRef = (0,react.useRef)(false);
    var isClosingRef = (0,react.useRef)(false);
    var ref1 = (0,react.useState)(defaultIsOpen ? "open" : "closed"), status = ref1[0], setStatus = ref1[1];
    var open = (0,react.useCallback)(function() {
        isOpenRef.current = false;
        isClosingRef.current = false;
        isOpeningRef.current = true;
        setStatus("opening");
        if (isAnimatingTimeoutRef.current) clearTimeout(isAnimatingTimeoutRef.current);
        isAnimatingTimeoutRef.current = setTimeout(function() {
            isOpeningRef.current = false;
            isOpenRef.current = true;
            setStatus("open");
        }, openingAnimationLength);
    }, [
        openingAnimationLength
    ]);
    var close = (0,react.useCallback)(function() {
        isClosingRef.current = true;
        isOpeningRef.current = false;
        setStatus("closing");
        if (isAnimatingTimeoutRef.current) clearTimeout(isAnimatingTimeoutRef.current);
        isAnimatingTimeoutRef.current = setTimeout(function() {
            isClosingRef.current = false;
            isOpenRef.current = false;
            setStatus("closed");
        }, closeAnimationLength);
    }, [
        closeAnimationLength
    ]);
    var toggle = (0,react.useCallback)(function() {
        if (isOpenRef.current || isOpeningRef.current) {
            close();
        } else {
            open();
        }
    }, [
        close,
        open
    ]);
    return {
        isOpen: isOpenRef.current,
        isOpening: isOpeningRef.current,
        isClosing: isClosingRef.current,
        status: status,
        open: open,
        close: close,
        toggle: toggle
    };
};

;// CONCATENATED MODULE: ./components/tools/map/ui/SidebarDrawer.tsx


function SidebarDrawer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  display: ",
        ";\n  bottom: 0;\n  left: 0;\n  z-index: ",
        ";\n  height: 100vh;\n  width: 100%;\n  overflow: hidden;\n\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.35s;\n  opacity: ",
        ";\n  transform: ",
        ";\n\n  ",
        " {\n    padding-left: var(--size-6);\n    padding-bottom: var(--size-3);\n    height: ",
        ";\n    max-width: calc(\n      var(--size-6) +\n        (\n          (100vw - var(--size-6) - var(--size-5) - 3 * var(--size-3)) *\n            (1 * ",
        ")\n        )\n    );\n\n    width: calc(\n      var(--size-6) + (100vw - var(--size-6) - var(--size-5) - 3 * var(--size-3)) *\n        (1 * ",
        ")\n    );\n\n    opacity: 1;\n\n    transition: transform 0.35s;\n\n    transform: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    SidebarDrawer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SidebarDrawer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  box-sizing: border-box;\n  background: #000;\n  pointer-events: all;\n  padding: var(--size-3) var(--size-4)\n    ",
        "\n    var(--size-4);\n\n  height: 100%;\n\n  & > div {\n    flex-grow: 1;\n    transition: opacity var(--transition-speed-link);\n    opacity: ",
        ";\n  }\n\n  & > div:first-child,\n  & > span:first-child,\n  & > div:last-child {\n    flex-grow: 0;\n    flex-shrink: 0;\n  }\n\n  ",
        " {\n    padding: var(--size-3) var(--size-4)\n    ",
        "\n  }\n  ",
        " {\n    padding: var(--size-3);\n    border-top-right-radius: var(--size-3);\n    border-bottom-right-radius: var(--size-3);\n  }\n"
    ]);
    SidebarDrawer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: var(--size-3);\n  flex-wrap: wrap;\n  align-items: center;\n  padding-right: var(--size-6);\n  padding-bottom: var(--size-3);\n\n  ",
        " {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--size-2);\n    padding-right: 0;\n  }\n\n  h3{\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










var SidebarContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adbd6b66-0"
})(SidebarDrawer_templateObject(), function(param) {
    var isInitializing = param.isInitializing;
    return isInitializing ? "none" : "block";
}, function(param) {
    var isOpening = param.isOpening, isOpen = param.isOpen;
    return isOpening || isOpen ? 5 : 4;
}, function(param) {
    var isOpening = param.isOpening, isOpen = param.isOpen, isClosing = param.isClosing;
    return isOpening || isOpen && !isClosing ? 1 : 0;
}, function(param) {
    var isOpening = param.isOpening, isOpen = param.isOpen, isClosing = param.isClosing;
    return isOpening || isOpen || isClosing ? "translateX(0)" : "translateX(-105vw)";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var hasTopOffset = param.hasTopOffset;
    return hasTopOffset ? "calc(100% - var(--lbh) - var(--tool-map-ot))" : "calc(100% - var(--lbh) - var(--size-3))";
}, function(param) {
    var columnWidth = param.columnWidth;
    return columnWidth;
}, function(param) {
    var columnWidth = param.columnWidth;
    return columnWidth;
}, function(param) {
    var isOpen = param.isOpen, isClosing = param.isClosing;
    return isClosing || !isOpen ? "translateX(calc(-100% - var(--size-6)))" : "translateX(0)";
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("noPrint");
});
var Panel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adbd6b66-1"
})(SidebarDrawer_templateObject1(), function(param) {
    var addCounterPadding = param.addCounterPadding;
    return addCounterPadding ? "calc(var(--size-7) + var(--size-3) + var(--size-2))" : "var(--size-3)";
}, function(param) {
    var isRefetching = param.isRefetching;
    return isRefetching ? 0.5 : 1;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var addCounterPadding = param.addCounterPadding;
    return addCounterPadding ? "calc(var(--size-6) + var(--size-2))" : "var(--size-3)";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
});
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adbd6b66-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var H3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-adbd6b66-3"
})(_templateObject3(), function(param) {
    var hasHeader = param.hasHeader;
    return hasHeader ? "0" : "0 0 var(--size-2) 0";
});
var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adbd6b66-4"
})(_templateObject4());
var CloseButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adbd6b66-5"
})(_templateObject5());
var openingAnimationLength = 350;
var closeAnimationLength = 350;
var SidebarDrawer = function(param) {
    var title = param.title, statusFlagKey = param.statusFlagKey, children = param.children, header = param.header, initiallyOpenOnLargerScreens = param.initiallyOpenOnLargerScreens, dimmContent = param.dimmContent, _columnWidth = param.columnWidth, columnWidth = _columnWidth === void 0 ? 0.333 : _columnWidth, _hasTopOffset = param.hasTopOffset, hasTopOffset = _hasTopOffset === void 0 ? true : _hasTopOffset, addCounterPadding = param.addCounterPadding;
    var isInitializing = (0,CssVarsState/* useCssVarsStateIsInitializingState */.Ob)();
    var isTabletLandscapeAndUp = (0,CssVarsState/* useCssVarsStateIsTabletLandscapeAndUpState */.Xb)();
    var filterState = (0,ToolState/* useToolStateFilterState */.QL)();
    var updateFilterState = (0,ToolState/* useToolStateStoreActions */.cH)().updateFilterState;
    var ref = useModal({
        defaultIsOpen: false,
        openingAnimationLength: openingAnimationLength,
        closeAnimationLength: closeAnimationLength
    }), isOpen = ref.isOpen, isOpening = ref.isOpening, isClosing = ref.isClosing, open = ref.open, close = ref.close;
    var ref1 = (0,react.useState)(false), initiallyStateSet = ref1[0], setInitiallyStateSet = ref1[1];
    var ref2;
    var isSidebarOpen = (ref2 = filterState === null || filterState === void 0 ? void 0 : filterState[statusFlagKey]) !== null && ref2 !== void 0 ? ref2 : false;
    (0,react.useEffect)(function() {
        (0,react.startTransition)(function() {
            if (isSidebarOpen) {
                open();
            } else {
                close();
            }
        });
    }, [
        isSidebarOpen,
        open,
        close
    ]);
    var closeSidebar = function() {
        updateFilterState((0,_define_property/* default */.Z)({}, statusFlagKey, false));
    };
    (0,react.useEffect)(function() {
        (0,react.startTransition)(function() {
            if (!isInitializing && isTabletLandscapeAndUp && initiallyOpenOnLargerScreens && !initiallyStateSet) {
                updateFilterState((0,_define_property/* default */.Z)({}, statusFlagKey, true));
                open();
                setInitiallyStateSet(true);
            }
        });
    }, [
        isInitializing,
        isTabletLandscapeAndUp,
        statusFlagKey,
        initiallyStateSet,
        initiallyOpenOnLargerScreens,
        updateFilterState,
        open, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarContainer, {
        columnWidth: columnWidth,
        hasTopOffset: hasTopOffset,
        isInitializing: isInitializing,
        isOpen: isOpen || isOpening,
        isOpening: isOpening,
        isClosing: isClosing,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Panel, {
            isLoading: false,
            isRefetching: false,
            addCounterPadding: !!addCounterPadding,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayBelow/* default */.Z, {
                            breakpoint: "tabletLandscape",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                onClick: closeSidebar,
                                type: "back",
                                className: "textLink back inBox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Close"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled/* Label */.__, {
                            children: title
                        }),
                        header
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled/* Scroller */.Tt, {
                    opacity: dimmContent ? 0.1 : 1,
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAbove/* default */.Z, {
                        breakpoint: "tabletLandscape",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                onClick: closeSidebar,
                                type: "back",
                                className: "textLink back inBox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Close"
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./utils/sanitize.ts
var sanitize = __webpack_require__(2938);
;// CONCATENATED MODULE: ./components/styled/Checkbox.tsx

function Checkbox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #fff;\n  background-color: #000;\n  appearance: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  width: var(--size-3);\n  height: var(--size-3);\n  cursor: pointer;\n\n  ",
        ' {\n    width: var(--size-2);\n    height: var(--size-2);\n  }\n  \n  &:after {\n    position: absolute;\n    content: "";\n    display: block;\n    width: calc(100% - 2px);\n    height: calc(100% - 2px);\n    top: 1px;\n    left: 1px;\n    background-color: #000;\n  }\n\n  &:checked {\n    &:after {\n      background-color: #fff;\n    }\n  }\n'
    ]);
    Checkbox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Checkbox = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-e8c44f0c-0"
})(Checkbox_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});

;// CONCATENATED MODULE: ./components/tools/map/ui/FieldCheckbox.tsx

function FieldCheckbox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  font-family: var(--font-family-sans-serif);\n  font-size: var(--text-small-font-size);\n  line-height: var(--text-small-line-height);\n\n  margin-bottom: ",
        ";\n  ",
        "\n"
    ]);
    FieldCheckbox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FieldCheckbox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: flex-start;\n  max-width: 100%;\n  \n  white-space: nowrap;\n  cursor: pointer;\n"
    ]);
    FieldCheckbox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FieldCheckbox_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  margin-top: 1px;\n"
    ]);
    FieldCheckbox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FieldCheckbox_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  padding-left: 0.5em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    FieldCheckbox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-96d91bb2-0"
})(FieldCheckbox_templateObject(), function(param) {
    var noMargin = param.noMargin;
    return noMargin ? "0" : "0.6em";
}, function(param) {
    var indent = param.indent;
    return indent > 0 ? "padding-left: ".concat(indent > 1 ? "calc(".concat(indent, " * var(--size-3))") : "var(--size-3)") : "";
});
var FieldCheckbox_Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-96d91bb2-1"
})(FieldCheckbox_templateObject1());
var Input = (0,styled_components_browser_esm/* default */.ZP)(Checkbox).withConfig({
    componentId: "sc-96d91bb2-2"
})(FieldCheckbox_templateObject2());
var FieldCheckbox_StyledLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-96d91bb2-3"
})(FieldCheckbox_templateObject3());
var FieldCheckbox = function(param) {
    var name = param.name, label = param.label, value = param.value, isChecked = param.isChecked, defaultChecked = param.defaultChecked, updateState = param.updateState, noMargin = param.noMargin, _indent = param.indent, indent = _indent === void 0 ? 0 : _indent;
    var id = (0,react.useId)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        noMargin: noMargin,
        indent: indent,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FieldCheckbox_Label, {
            htmlFor: id,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                    type: "checkbox",
                    name: name,
                    id: id,
                    value: value,
                    defaultChecked: defaultChecked,
                    checked: isChecked,
                    onChange: updateState
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldCheckbox_StyledLabel, {
                    dangerouslySetInnerHTML: {
                        __html: (0,sanitize/* default */.Z)(label)
                    }
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/tools/map/ui/TaxonomyCheckboxGroup.tsx

function TaxonomyCheckboxGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    TaxonomyCheckboxGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TaxonomyCheckboxGroup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    TaxonomyCheckboxGroup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TaxonomyCheckboxGroup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: 0.5em;\n"
    ]);
    TaxonomyCheckboxGroup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var TaxonomyCheckboxGroup_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cc6bfa3-0"
})(TaxonomyCheckboxGroup_templateObject());
var Options = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cc6bfa3-1"
})(TaxonomyCheckboxGroup_templateObject1());
var H4 = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-9cc6bfa3-2"
})(TaxonomyCheckboxGroup_templateObject2());
var TaxonomyCheckboxGroup = function(param) {
    var label = param.label, options = param.options, activeTerms = param.activeTerms, updateState = param.updateState;
    if (!(options === null || options === void 0 ? void 0 : options.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TaxonomyCheckboxGroup_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(H4, {
                children: (0,sanitize/* default */.Z)(label)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldCheckbox, {
                        label: option.name,
                        value: option.id,
                        name: "field-".concat(option.id),
                        isChecked: option.id in (activeTerms !== null && activeTerms !== void 0 ? activeTerms : {}),
                        updateState: function(event) {
                            updateState(option.id, option.name, event.target.checked);
                        }
                    }, "tax-".concat(label, "-").concat(option.id));
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tools/map/ui/ActiveFilterOption.tsx

function ActiveFilterOption_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  font-size: var(--text-small-font-size);\n  line-height: var(--text-small-line-height);\n  border-radius: 4px;\n  background-color: var(--color-dark-grey);\n  border: 1px solid #fff;\n  padding: 0.3em 0 0.5em 0.5em;\n  gap: var(--size-1);\n  max-width: 100%;\n"
    ]);
    ActiveFilterOption_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ActiveFilterOption_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  overflow: hidden;\n  // hyphens: auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n"
    ]);
    ActiveFilterOption_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Option = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-564bc4bd-0"
})(ActiveFilterOption_templateObject());
var Trim = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-564bc4bd-1"
})(ActiveFilterOption_templateObject1());
var ActiveFilterOption = function(param) {
    var label = param.label, onRemove = param.onRemove;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Trim, {
                dangerouslySetInnerHTML: {
                    __html: (0,sanitize/* default */.Z)(label)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                type: "close",
                onClick: onRemove
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tools/map/ui/CheckboxGroup.tsx

function CheckboxGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    CheckboxGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckboxGroup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--size-2);\n"
    ]);
    CheckboxGroup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckboxGroup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: 0.5em;\n"
    ]);
    CheckboxGroup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var CheckboxGroup_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43d03214-0"
})(CheckboxGroup_templateObject());
var CheckboxGroup_Options = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43d03214-1"
})(CheckboxGroup_templateObject1());
var CheckboxGroup_H4 = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-43d03214-2"
})(CheckboxGroup_templateObject2());
var CheckboxGroup = function(param) {
    var label = param.label, options = param.options, activeTerms = param.activeTerms, updateState = param.updateState;
    if (!(options === null || options === void 0 ? void 0 : options.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckboxGroup_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxGroup_H4, {
                children: (0,sanitize/* default */.Z)(label)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxGroup_Options, {
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldCheckbox, {
                        noMargin: true,
                        label: option.name,
                        value: option.id,
                        name: "field-".concat(option.id),
                        isChecked: option.id in (activeTerms !== null && activeTerms !== void 0 ? activeTerms : {}),
                        updateState: function(event) {
                            updateState(option.id, option.name, event.target.checked);
                        }
                    }, "tax-".concat(label, "-").concat(option.id));
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./hooks/useRanger.jsx





var getBoundingClientRect = function(element) {
    var rect = element.getBoundingClientRect();
    return {
        left: Math.ceil(rect.left),
        width: Math.ceil(rect.width)
    };
};
var sortNumList = function(arr) {
    return (0,_to_consumable_array/* default */.Z)(arr).sort(function(a, b) {
        return Number(a) - Number(b);
    });
};
var useGetLatest = function(val) {
    var ref = react.useRef(val);
    ref.current = val;
    return react.useCallback(function() {
        return ref.current;
    }, []);
};
var linearInterpolator = {
    getPercentageForValue: function(val, min, max) {
        return Math.max(0, Math.min(100, (val - min) / (max - min) * 100));
    },
    getValueForClientX: function(clientX, trackDims, min, max) {
        var left = trackDims.left, width = trackDims.width;
        var percentageValue = (clientX - left) / width;
        var value = (max - min) * percentageValue;
        return value + min;
    }
};
function useRanger(param) {
    var _interpolator = param.interpolator, interpolator = _interpolator === void 0 ? linearInterpolator : _interpolator, _tickSize = param.tickSize, tickSize = _tickSize === void 0 ? 10 : _tickSize, values = param.values, min = param.min, max = param.max, controlledTicks = param.ticks, steps = param.steps, onChange = param.onChange, onDrag = param.onDrag, stepSize = param.stepSize;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), activeHandleIndex = ref[0], setActiveHandleIndex = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), tempValues = ref1[0], setTempValues = ref1[1];
    var getLatest = useGetLatest({
        activeHandleIndex: activeHandleIndex,
        onChange: onChange,
        onDrag: onDrag,
        values: values,
        tempValues: tempValues
    });
    var trackElRef = react.useRef();
    var getValueForClientX = react.useCallback(function(clientX) {
        var trackDims = getBoundingClientRect(trackElRef.current);
        return interpolator.getValueForClientX(clientX, trackDims, min, max);
    }, [
        interpolator,
        max,
        min
    ]);
    var getNextStep = react.useCallback(function(val, direction) {
        if (steps) {
            var currIndex = steps.indexOf(val);
            var nextIndex = currIndex + direction;
            if (nextIndex >= 0 && nextIndex < steps.length) {
                return steps[nextIndex];
            } else {
                return val;
            }
        } else {
            if (false) {}
            var nextVal = val + stepSize * direction;
            if (nextVal >= min && nextVal <= max) {
                return nextVal;
            } else {
                return val;
            }
        }
    }, [
        max,
        min,
        stepSize,
        steps
    ]);
    var roundToStep = react.useCallback(function(val) {
        var left = min;
        var right = max;
        if (steps) {
            steps.forEach(function(step) {
                if (step <= val && step > left) {
                    left = step;
                }
                if (step >= val && step < right) {
                    right = step;
                }
            });
        } else {
            if (false) {}
            while(left < val && left + stepSize < val){
                left += stepSize;
            }
            right = Math.min(left + stepSize, max);
        }
        if (val - left < right - val) {
            return left;
        }
        return right;
    }, [
        max,
        min,
        stepSize,
        steps
    ]);
    var handleDrag = react.useCallback(function(e) {
        var ref = getLatest(), activeHandleIndex = ref.activeHandleIndex, onDrag = ref.onDrag;
        var clientX = e.type === "touchmove" ? e.changedTouches[0].clientX : e.clientX;
        var newValue = getValueForClientX(clientX);
        var newRoundedValue = roundToStep(newValue);
        var newValues = (0,_to_consumable_array/* default */.Z)(values.slice(0, activeHandleIndex)).concat([
            newRoundedValue, 
        ], (0,_to_consumable_array/* default */.Z)(values.slice(activeHandleIndex + 1)));
        if (onDrag) {
            onDrag(newValues);
        } else {
            setTempValues(newValues);
        }
    }, [
        getLatest,
        getValueForClientX,
        roundToStep,
        values
    ]);
    var handleKeyDown = react.useCallback(function(e, i) {
        var ref = getLatest(), values = ref.values, _onChange = ref.onChange, onChange = _onChange === void 0 ? function() {} : _onChange;
        // Left Arrow || Right Arrow
        if (e.keyCode === 37 || e.keyCode === 39) {
            setActiveHandleIndex(i);
            var direction = e.keyCode === 37 ? -1 : 1;
            var newValue = getNextStep(values[i], direction);
            var newValues = (0,_to_consumable_array/* default */.Z)(values.slice(0, i)).concat([
                newValue, 
            ], (0,_to_consumable_array/* default */.Z)(values.slice(i + 1)));
            var sortedValues = sortNumList(newValues);
            onChange(sortedValues);
        }
    }, [
        getLatest,
        getNextStep
    ]);
    var handlePress = react.useCallback(function(e, i) {
        setActiveHandleIndex(i);
        var handleRelease = function(e) {
            var ref = getLatest(), tempValues = ref.tempValues, values = ref.values, _onChange = ref.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _onDrag = ref.onDrag, onDrag = _onDrag === void 0 ? function() {} : _onDrag;
            document.removeEventListener("mousemove", handleDrag);
            document.removeEventListener("touchmove", handleDrag);
            document.removeEventListener("mouseup", handleRelease);
            document.removeEventListener("touchend", handleRelease);
            var sortedValues = sortNumList(tempValues || values);
            onChange(sortedValues);
            onDrag(sortedValues);
            setActiveHandleIndex(null);
            setTempValues();
        };
        document.addEventListener("mousemove", handleDrag);
        document.addEventListener("touchmove", handleDrag);
        document.addEventListener("mouseup", handleRelease);
        document.addEventListener("touchend", handleRelease);
    }, [
        getLatest,
        handleDrag
    ]);
    var getPercentageForValue = react.useCallback(function(val) {
        return interpolator.getPercentageForValue(val, min, max);
    }, [
        interpolator,
        max,
        min
    ]);
    // Build the ticks
    var ticks = react.useMemo(function() {
        var ticks = controlledTicks || steps;
        if (!ticks) {
            ticks = [
                min
            ];
            while(ticks[ticks.length - 1] < max - tickSize){
                ticks.push(ticks[ticks.length - 1] + tickSize);
            }
            ticks.push(max);
        }
        return ticks.map(function(value, i) {
            return {
                value: value,
                getTickProps: function() {
                    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    var _key = _param.key, key = _key === void 0 ? i : _key, _style = _param.style, style = _style === void 0 ? {} : _style, rest = (0,_object_without_properties/* default */.Z)(_param, [
                        "key",
                        "style"
                    ]);
                    return (0,_object_spread/* default */.Z)({
                        key: key,
                        style: (0,_object_spread/* default */.Z)({
                            position: "absolute",
                            width: 0,
                            left: "".concat(getPercentageForValue(value), "%"),
                            transform: "translateX(-50%)"
                        }, style)
                    }, rest);
                }
            };
        });
    }, [
        controlledTicks,
        getPercentageForValue,
        max,
        min,
        steps,
        tickSize
    ]);
    var segments = react.useMemo(function() {
        var sortedValues = sortNumList(tempValues || values);
        return (0,_to_consumable_array/* default */.Z)(sortedValues).concat([
            max
        ]).map(function(value, i) {
            return {
                value: value,
                getSegmentProps: function() {
                    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    var _key = _param.key, key = _key === void 0 ? i : _key, _style = _param.style, style = _style === void 0 ? {} : _style, rest = (0,_object_without_properties/* default */.Z)(_param, [
                        "key",
                        "style"
                    ]);
                    var left = getPercentageForValue(sortedValues[i - 1] ? sortedValues[i - 1] : min);
                    var width = getPercentageForValue(value) - left;
                    return (0,_object_spread/* default */.Z)({
                        key: key,
                        style: (0,_object_spread/* default */.Z)({
                            position: "absolute",
                            left: "".concat(left, "%"),
                            width: "".concat(width, "%")
                        }, style)
                    }, rest);
                }
            };
        });
    }, [
        getPercentageForValue,
        max,
        min,
        tempValues,
        values
    ]);
    var handles = react.useMemo(function() {
        return (tempValues || values).map(function(value, i) {
            return {
                value: value,
                active: i === activeHandleIndex,
                getHandleProps: function() {
                    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    var _key = _param.key, key = _key === void 0 ? i : _key, ref = _param.ref, _innerRef = _param.innerRef, innerRef = _innerRef === void 0 ? function() {} : _innerRef, onKeyDown = _param.onKeyDown, onMouseDown = _param.onMouseDown, onTouchStart = _param.onTouchStart, _style = _param.style, style = _style === void 0 ? {} : _style, rest = (0,_object_without_properties/* default */.Z)(_param, [
                        "key",
                        "ref",
                        "innerRef",
                        "onKeyDown",
                        "onMouseDown",
                        "onTouchStart",
                        "style"
                    ]);
                    return (0,_object_spread/* default */.Z)({
                        key: key,
                        onKeyDown: function(e) {
                            e.persist();
                            handleKeyDown(e, i);
                            if (onKeyDown) onKeyDown(e);
                        },
                        onMouseDown: function(e) {
                            e.persist();
                            handlePress(e, i);
                            if (onMouseDown) onMouseDown(e);
                        },
                        onTouchStart: function(e) {
                            e.persist();
                            handlePress(e, i);
                            if (onTouchStart) onTouchStart(e);
                        },
                        role: "slider",
                        "aria-valuemin": min,
                        "aria-valuemax": max,
                        "aria-valuenow": value,
                        style: (0,_object_spread/* default */.Z)({
                            position: "absolute",
                            top: "50%",
                            left: "".concat(getPercentageForValue(value), "%"),
                            zIndex: i === activeHandleIndex ? "1" : "0",
                            transform: "translate(-50%, -50%)"
                        }, style)
                    }, rest);
                }
            };
        });
    }, [
        activeHandleIndex,
        getPercentageForValue,
        handleKeyDown,
        handlePress,
        min,
        max,
        tempValues,
        values, 
    ]);
    var getTrackProps = function() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _style = _param.style, style = _style === void 0 ? {} : _style, ref = _param.ref, rest = (0,_object_without_properties/* default */.Z)(_param, [
            "style",
            "ref"
        ]);
        return (0,_object_spread/* default */.Z)({
            ref: function(el) {
                trackElRef.current = el;
                if (ref) {
                    if (typeof ref === "function") {
                        ref(el);
                    } else {
                        ref.current = el;
                    }
                }
            },
            style: (0,_object_spread/* default */.Z)({
                position: "relative",
                userSelect: "none"
            }, style)
        }, rest);
    };
    return {
        activeHandleIndex: activeHandleIndex,
        getTrackProps: getTrackProps,
        ticks: ticks,
        segments: segments,
        handles: handles
    };
}

;// CONCATENATED MODULE: ./components/tools/map/ui/RangeSlider.tsx



function RangeSlider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RangeSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RangeSlider_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: var(--size-3);\n  padding-bottom: var(--size-1);\n"
    ]);
    RangeSlider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RangeSlider_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 2 * var(--size-3) - 15px - 2 * var(--size-4));\n"
    ]);
    RangeSlider_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RangeSlider_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: var(--size-4);\n"
    ]);
    RangeSlider_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RangeSlider_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: translateY(-3px);\n  display: inline-block;\n  height: 4px;\n  width: 100%;\n"
    ]);
    RangeSlider_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RangeSlider_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  :before {\n    content: "";\n    position: absolute;\n    left: 0;\n    background: var(--color-dark-grey);\n    height: 16px;\n    width: 2px;\n    transform: translate(-50%, -6px);\n  }\n'
    ]);
    RangeSlider_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  font-size: 0.6rem;\n  color: rgba(0, 0, 0, 0.5);\n  top: 100%;\n  transform: translate(-50%, 1.2rem);\n  white-space: nowrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  height: 100%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  font-size: 0.7rem;\n  white-space: nowrap;\n  color: white;\n  cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: 0.5em;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var RangeSlider_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a532f2f-0"
})(RangeSlider_templateObject());
var SliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a532f2f-1"
})(RangeSlider_templateObject1());
var Slider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a532f2f-2"
})(RangeSlider_templateObject2());
var Value = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a532f2f-3"
})(RangeSlider_templateObject3());
var Track = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a532f2f-4"
})(RangeSlider_templateObject4());
var Tick = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a532f2f-5"
})(RangeSlider_templateObject5());
var TickLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a532f2f-6"
})(_templateObject6());
var Segment = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a532f2f-7"
})(_templateObject7(), function(props) {
    return props.index === 0 ? "var(--color-medium-grey)" : props.index === 1 ? "#fff" : props.index === 2 ? "var(--color-medium-grey)" : "var(--color-medium-grey)";
});
var Handle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a532f2f-8"
})(_templateObject8());
var RangeSlider_H4 = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-2a532f2f-9"
})(_templateObject9());
var RangeSlider = function(param) {
    var label = param.label, min = param.min, max = param.max, valueFrom = param.valueFrom, valueUntil = param.valueUntil, stepSize = param.stepSize, updateState = param.updateState;
    var id = (0,react.useId)();
    var ref = (0,react.useState)([
        valueFrom,
        valueUntil
    ]), values = ref[0], setValues = ref[1];
    var ref1 = useRanger({
        min: min,
        max: max,
        stepSize: stepSize,
        values: values,
        tickSize: 1,
        onDrag: setValues,
        onChange: updateState
    }), getTrackProps = ref1.getTrackProps, segments = ref1.segments, handles = ref1.handles;
    (0,react.useEffect)(function() {
        setValues([
            valueFrom,
            valueUntil
        ]);
    }, [
        valueFrom,
        valueUntil
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RangeSlider_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSlider_H4, {
                children: (0,sanitize/* default */.Z)(label)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                        children: values[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Track, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getTrackProps()), {
                            children: [
                                segments.map(function(param, i) {
                                    var getSegmentProps = param.getSegmentProps;
                                    return /*#__PURE__*/ (0,react.createElement)(Segment, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getSegmentProps()), {
                                        index: i,
                                        key: "".concat(id, "-segment-").concat(i)
                                    }));
                                }),
                                handles.map(function(param, i) {
                                    var value = param.value, active = param.active, getHandleProps = param.getHandleProps;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getHandleProps({
                                        style: {
                                            appearance: "none",
                                            border: "none",
                                            background: "transparent",
                                            outline: "none"
                                        }
                                    })), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Handle, {
                                            active: active
                                        })
                                    }), "".concat(id, "-thumb-").concat(i));
                                })
                            ]
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                        children: values[1]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/ui/Reveal.tsx
var Reveal = __webpack_require__(1663);
;// CONCATENATED MODULE: ./components/tools/map/ui/ClearAll.tsx

function ClearAll_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-left: auto;\n  \n  button{\n    ",
        ";\n    align-items: center;\n    gap: 0;\n  }\n"
    ]);
    ClearAll_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ClearAllContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3de360d3-0"
})(ClearAll_templateObject(), function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
});
var ClearAll = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearAllContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
            type: "close",
            onClick: onClick,
            children: "Clear all"
        })
    });
};

;// CONCATENATED MODULE: ./components/tools/map/ui/RegionOrCountrySelector.tsx

function RegionOrCountrySelector_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    RegionOrCountrySelector_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RegionOrCountrySelector_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: var(--size-3);\n"
    ]);
    RegionOrCountrySelector_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RegionOrCountrySelector_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    RegionOrCountrySelector_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RegionOrCountrySelector_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  gap: var(--size-3);\n"
    ]);
    RegionOrCountrySelector_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RegionOrCountrySelector_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--size-1);\n  flex-grow: 1;\n\n  & .labelAll{\n    color: var(--color-light-grey);\n    font-family: var(--font-family-monospace);\n    font-size: var(--text-small-font-size);\n  }\n"
    ]);
    RegionOrCountrySelector_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RegionOrCountrySelector_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 0;\n\n  & .svg{\n    min-height: var(--size-2);\n  }\n"
    ]);
    RegionOrCountrySelector_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RegionOrCountrySelector_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: var(--size-3);\n"
    ]);
    RegionOrCountrySelector_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









var RegionOrCountrySelector_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-318adc18-0"
})(RegionOrCountrySelector_templateObject());
var OptionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-318adc18-1"
})(RegionOrCountrySelector_templateObject1());
var RegionOrCountrySelector_H4 = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-318adc18-2"
})(RegionOrCountrySelector_templateObject2());
var Active = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-318adc18-3"
})(RegionOrCountrySelector_templateObject3());
var Selected = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-318adc18-4"
})(RegionOrCountrySelector_templateObject4());
var Add = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-318adc18-5"
})(RegionOrCountrySelector_templateObject5());
var OptionsClose = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-318adc18-6"
})(RegionOrCountrySelector_templateObject6());
var renderOptions = function(label, activeTerms, options, updateState) {
    var indent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, allOptions = arguments.length > 5 ? arguments[5] : void 0, debug = arguments.length > 6 ? arguments[6] : void 0;
    if (!(options === null || options === void 0 ? void 0 : options.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return options.reduce(function(carry, option, index) {
        var ref;
        carry.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(FieldCheckbox, {
            indent: indent,
            label: option.name,
            value: option.id,
            name: "field-".concat(option.id),
            isChecked: option.id in (activeTerms !== null && activeTerms !== void 0 ? activeTerms : {}),
            updateState: function(event) {
                var ref;
                var newstate = {
                    ids: [],
                    name: [],
                    checked: []
                };
                if (option === null || option === void 0 ? void 0 : (ref = option.children) === null || ref === void 0 ? void 0 : ref.length) {
                    newstate = option.children.reduce(function(carry, o) {
                        carry.ids.push(o.id);
                        carry.name.push(o.name);
                        carry.checked.push(event.target.checked);
                        return carry;
                    }, newstate);
                }
                newstate.ids.push(option.id);
                newstate.name.push(option.name);
                newstate.checked.push(event.target.checked);
                if (!event.target.checked && (option === null || option === void 0 ? void 0 : option.parent)) {
                    newstate.ids.push(option.parent);
                    newstate.name.push("");
                    newstate.checked.push(false);
                }
                updateState(newstate.ids, newstate.name, newstate.checked);
            }
        }, "".concat(label, "-").concat(option.id, "-").concat(index)));
        if (option === null || option === void 0 ? void 0 : (ref = option.children) === null || ref === void 0 ? void 0 : ref.length) carry = renderOptions(label, activeTerms, option === null || option === void 0 ? void 0 : option.children, updateState, indent + 1, carry, debug);
        return carry;
    }, allOptions);
};
var RegionOrCountrySelector = function(param) {
    var label = param.label, labelAllShown = param.labelAllShown, options = param.options, activeTerms = param.activeTerms, debug = param.debug, updateState = param.updateState, clearAllOnClick = param.clearAllOnClick;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegionOrCountrySelector_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegionOrCountrySelector_H4, {
                children: [
                    (0,sanitize/* default */.Z)(label),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Add, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            className: "textLink",
                            type: isOpen ? "minus" : "plus",
                            onClick: function() {
                                setIsOpen(!isOpen);
                            },
                            children: isOpen ? "Collapse" : "Select"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Active, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Selected, {
                    children: [
                        Object.keys(activeTerms !== null && activeTerms !== void 0 ? activeTerms : {}).length > 0 && Object.keys(activeTerms !== null && activeTerms !== void 0 ? activeTerms : {}).map(function(termId) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ActiveFilterOption, {
                                onRemove: function() {
                                    updateState(termId, "", false);
                                },
                                label: (ref1 = (ref = activeTerms !== null && activeTerms !== void 0 ? activeTerms : {}) === null || ref === void 0 ? void 0 : ref[termId]) !== null && ref1 !== void 0 ? ref1 : "unknown"
                            }, "term-".concat(termId));
                        }),
                        Object.keys(activeTerms !== null && activeTerms !== void 0 ? activeTerms : {}).length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "labelAll",
                            onClick: function() {
                                setIsOpen(!isOpen);
                            },
                            children: labelAllShown
                        }),
                        typeof clearAllOnClick === "function" && Object.keys(activeTerms !== null && activeTerms !== void 0 ? activeTerms : {}).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearAll, {
                            onClick: clearAllOnClick
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reveal/* Reveal */.U, {
                open: isOpen,
                id: "".concat(label, "-options"),
                role: "region",
                position: "top",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsContainer, {
                    children: renderOptions(label, activeTerms, options, updateState, 0, [], !!debug)
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tools/map/FilterContent.tsx





function FilterContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  gap: var(--size-3);\n  flex-direction: column;\n\n  hr {\n    border-top: 1px solid #ccc;\n    margin: var(--size-1) 0;\n    clear: both;\n  }\n\n  padding-bottom: ",
        ";\n\n  ",
        " {\n    padding-bottom: 0;\n  }\n"
    ]);
    FilterContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterContent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  /*\n    border-top: ",
        ";\n    padding-top: var(--size-1);\n    margin-top: ",
        ";\n  */\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--size-1);\n"
    ]);
    FilterContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var FilterContent_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ce162bc1-0"
})(FilterContent_templateObject(), function(param) {
    var isDirectory = param.isDirectory;
    return isDirectory ? "var(--size-7)" : 0;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var ActiveFilters = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ce162bc1-1"
})(FilterContent_templateObject1(), function(param) {
    var withRegions = param.withRegions;
    return withRegions ? "1px solid #fff" : "none";
}, function(param) {
    var withRegions = param.withRegions;
    return withRegions ? "var(--size-3)" : "0";
});
var FilterContent = function(param) {
    var view = param.view;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var router = (0,next_router.useRouter)();
    var config = (0,ConfigContextProvider/* useConfigContext */.q)();
    var mapTool = config === null || config === void 0 ? void 0 : (ref = config.tools) === null || ref === void 0 ? void 0 : ref.find(function(t) {
        return t.slug === "map";
    });
    var filterState = (0,ToolState/* useToolStateFilterState */.QL)();
    var settingsState = (0,ToolState/* useToolStateSettingsState */.wk)();
    var ref12 = (0,ToolState/* useToolStateStoreActions */.cH)(), getDefaultState = ref12.getDefaultState, getFilterState = ref12.getFilterState, setFilterState = ref12.setFilterState, updateFilterState = ref12.updateFilterState;
    var maybeUpdateQueryString = (0,react.useCallback)(function(state) {
        var newQueryString = (0,utils/* createCompareQueryFromState */.zu)(state);
        var _search;
        if (newQueryString !== ((_search = document.location.search) !== null && _search !== void 0 ? _search : "").replace("&empty=1", "")) {
            router.push({
                pathname: router.pathname,
                search: newQueryString !== "" ? newQueryString : "?empty=1"
            }, undefined, {
                shallow: true
            });
        }
    }, [
        router
    ]);
    var updateFormStateRecord = function(key, id, label, checked) {
        var currentState = getFilterState();
        if (!(currentState === null || currentState === void 0 ? void 0 : currentState[key]) || !currentState[key]) return;
        var ids = Array.isArray(id) ? id : [
            id
        ];
        var labels = Array.isArray(label) ? label : [
            label
        ];
        var arrChecked = Array.isArray(checked) ? checked : [
            checked
        ];
        if (ids.length !== labels.length || labels.length !== arrChecked.length) return;
        if ((0,_instanceof/* default */.Z)(currentState[key], Object) && currentState[key]) {
            ids.forEach(function(val, index) {
                if (arrChecked[index]) {
                    var _key;
                    if (!(val in ((_key = currentState[key]) !== null && _key !== void 0 ? _key : {}))) {
                        currentState[key][val] = labels[index];
                    }
                } else {
                    var _key1;
                    if (val in ((_key1 = currentState[key]) !== null && _key1 !== void 0 ? _key1 : {})) {
                        delete currentState[key][val];
                    }
                }
            });
            maybeUpdateQueryString(currentState);
        }
    };
    var updateTaxonomyState = function(id, label, checked) {
        updateFormStateRecord("terms", id, label, checked);
    };
    var resetFilter = (0,react.useCallback)(function() {
        var newState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getDefaultState().filter), {
            isFilterOpen: true,
            quickViewProjectId: getFilterState().quickViewProjectId,
            totalCount: getFilterState().totalCount,
            filteredCount: getFilterState().totalCount,
            regions: getFilterState().regions,
            countries: getFilterState().countries
        });
        setFilterState(newState);
        maybeUpdateQueryString(newState);
    }, [
        getDefaultState,
        setFilterState,
        getFilterState,
        maybeUpdateQueryString
    ]);
    var activeFilters = [];
    activeFilters = [
        "terms",
        "license",
        "genderRatio"
    ].reduce(function(carry, key) {
        var _key, _key1, ref;
        return (0,_to_consumable_array/* default */.Z)(carry).concat((0,_to_consumable_array/* default */.Z)(Object.keys((_key = filterState[key]) !== null && _key !== void 0 ? _key : {}).map(function(id) {
            var ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ActiveFilterOption, {
                onRemove: function() {
                    updateFormStateRecord(key, id, "", false);
                },
                label: (ref = (ref1 = (_key1 = filterState[key]) !== null && _key1 !== void 0 ? _key1 : {}) === null || ref1 === void 0 ? void 0 : ref1[id]) !== null && ref !== void 0 ? ref : "unknown"
            }, "active-".concat(key, "-").concat(id));
        })));
    }, []);
    if (filterState.dateFrom && filterState.dateUntil) {
        activeFilters.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveFilterOption, {
            onRemove: function() {
                var currentState = getFilterState();
                currentState.dateFrom = null;
                currentState.dateUntil = null;
                maybeUpdateQueryString(currentState);
            },
            label: "".concat(filterState.dateFrom, " - ").concat(filterState.dateUntil)
        }, "active-date"));
    }
    var ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, _dateFrom, ref26, _dateUntil;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterContent_Container, {
        isDirectory: view !== "map",
        children: [
            view !== "map" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionOrCountrySelector, {
                label: "Regions",
                labelAllShown: "All regions",
                activeTerms: (ref13 = filterState === null || filterState === void 0 ? void 0 : filterState.regions) !== null && ref13 !== void 0 ? ref13 : {},
                options: (ref14 = settingsState === null || settingsState === void 0 ? void 0 : settingsState.regions) !== null && ref14 !== void 0 ? ref14 : [],
                clearAllOnClick: function() {
                    updateFilterState({
                        regions: {}
                    });
                },
                updateState: function(id, label, checked) {
                    updateFormStateRecord("regions", id, label, checked);
                }
            }),
            view !== "map" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionOrCountrySelector, {
                        label: "Countries",
                        labelAllShown: "All countries",
                        activeTerms: (ref15 = filterState === null || filterState === void 0 ? void 0 : filterState.countries) !== null && ref15 !== void 0 ? ref15 : {},
                        options: (ref16 = settingsState === null || settingsState === void 0 ? void 0 : settingsState.countries) !== null && ref16 !== void 0 ? ref16 : [],
                        clearAllOnClick: function() {
                            updateFilterState({
                                countries: {}
                            });
                        },
                        updateState: function(id, label, checked) {
                            updateFormStateRecord("countries", id, label, checked);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                ]
            }),
            (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActiveFilters, {
                withRegions: view !== "map",
                children: [
                    activeFilters,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearAll, {
                        onClick: function() {
                            resetFilter();
                        }
                    })
                ]
            }),
            ((ref17 = settingsState === null || settingsState === void 0 ? void 0 : (ref1 = settingsState.industrialSector) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.options) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref17 !== void 0 ? ref17 : 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxonomyCheckboxGroup, {
                label: "Industrial Sector",
                activeTerms: (ref18 = filterState === null || filterState === void 0 ? void 0 : filterState.terms) !== null && ref18 !== void 0 ? ref18 : {},
                options: settingsState === null || settingsState === void 0 ? void 0 : (ref3 = settingsState.industrialSector) === null || ref3 === void 0 ? void 0 : ref3.options,
                updateState: updateTaxonomyState
            }),
            ((ref19 = settingsState === null || settingsState === void 0 ? void 0 : (ref4 = settingsState.industrialSector) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.options) === null || ref5 === void 0 ? void 0 : ref5.length) !== null && ref19 !== void 0 ? ref19 : 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxonomyCheckboxGroup, {
                label: "Use of AI",
                activeTerms: (ref20 = filterState === null || filterState === void 0 ? void 0 : filterState.terms) !== null && ref20 !== void 0 ? ref20 : {},
                options: settingsState === null || settingsState === void 0 ? void 0 : (ref6 = settingsState.useOfAi) === null || ref6 === void 0 ? void 0 : ref6.options,
                updateState: updateTaxonomyState
            }),
            ((ref21 = settingsState === null || settingsState === void 0 ? void 0 : (ref7 = settingsState.funding) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.options) === null || ref8 === void 0 ? void 0 : ref8.length) !== null && ref21 !== void 0 ? ref21 : 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxonomyCheckboxGroup, {
                label: "Type of funding",
                activeTerms: (ref22 = filterState === null || filterState === void 0 ? void 0 : filterState.terms) !== null && ref22 !== void 0 ? ref22 : {},
                options: settingsState === null || settingsState === void 0 ? void 0 : (ref9 = settingsState.funding) === null || ref9 === void 0 ? void 0 : ref9.options,
                updateState: updateTaxonomyState
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxGroup, {
                label: "Code license",
                activeTerms: (ref23 = filterState === null || filterState === void 0 ? void 0 : filterState.license) !== null && ref23 !== void 0 ? ref23 : {},
                options: settingsState.license,
                updateState: function(id, label, checked) {
                    updateFormStateRecord("license", id, label, checked);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxGroup, {
                label: "Gender ratio",
                activeTerms: (ref24 = filterState === null || filterState === void 0 ? void 0 : filterState.genderRatio) !== null && ref24 !== void 0 ? ref24 : {},
                options: settingsState.genderRatio,
                updateState: function(id, label, checked) {
                    updateFormStateRecord("genderRatio", id, label, checked);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSlider, {
                label: "Release date between",
                min: (ref25 = mapTool === null || mapTool === void 0 ? void 0 : (ref10 = mapTool.config) === null || ref10 === void 0 ? void 0 : ref10.minYear) !== null && ref25 !== void 0 ? ref25 : 1996,
                max: new Date().getFullYear(),
                valueFrom: (ref26 = (_dateFrom = filterState.dateFrom) !== null && _dateFrom !== void 0 ? _dateFrom : mapTool === null || mapTool === void 0 ? void 0 : (ref11 = mapTool.config) === null || ref11 === void 0 ? void 0 : ref11.minYear) !== null && ref26 !== void 0 ? ref26 : 1996,
                valueUntil: (_dateUntil = filterState.dateUntil) !== null && _dateUntil !== void 0 ? _dateUntil : new Date().getFullYear(),
                stepSize: 1,
                updateState: function(values) {
                    var ref;
                    var currentState = getFilterState();
                    if ((values === null || values === void 0 ? void 0 : values.length) !== 2) return;
                    var ref1;
                    if (values[0] === ((ref1 = mapTool === null || mapTool === void 0 ? void 0 : (ref = mapTool.config) === null || ref === void 0 ? void 0 : ref.minYear) !== null && ref1 !== void 0 ? ref1 : 1996) && values[1] === new Date().getFullYear()) {
                        currentState.dateFrom = null;
                        currentState.dateUntil = null;
                    } else {
                        currentState.dateFrom = values[0];
                        currentState.dateUntil = values[1];
                    }
                    maybeUpdateQueryString(currentState);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tools/map/MapFilter.tsx



var MapFilter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarDrawer, {
        columnWidth: 0.333,
        initiallyOpenOnLargerScreens: true,
        statusFlagKey: "isFilterOpen",
        title: "Project filter",
        addCounterPadding: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterContent, {
            view: "map"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 8 modules
var useQuery = __webpack_require__(7837);
// EXTERNAL MODULE: ./components/styled/Button.tsx
var Button = __webpack_require__(5301);
// EXTERNAL MODULE: ./config/index.ts + 1 modules
var config = __webpack_require__(5740);
// EXTERNAL MODULE: ./components/tools/map/ProjectCard.tsx + 1 modules
var ProjectCard = __webpack_require__(7200);
;// CONCATENATED MODULE: ./components/tools/map/ProjectQuickView.tsx



function ProjectQuickView_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: var(--size-3);\n  left: calc(var(--size-3) + var(--size-6));\n  z-index: 25;\n  height: auto;\n  max-height: 75vh;\n  width: calc((100vw - var(--size-6) - 3 * var(--size-3)) * 0.333);\n  border-radius: var(--size-3);\n  overflow: hidden;\n  transition: transform 0.35s, width 0.35s;\n  transform: ",
        ";\n\n  ",
        "\n\n  @media print {\n    position: static;\n    transform: none;\n    width: 100%;\n    height: auto;\n    max-height: auto;\n  }\n"
    ]);
    ProjectQuickView_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProjectQuickView_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  box-sizing: border-box;\n  background: #000;\n  pointer-events: all;\n  padding: var(--size-3);\n\n  height: ",
        ";\n\n  & > div {\n    flex-grow: 1;\n    transition: opacity var(--transition-speed-link);\n    opacity: ",
        ";\n  }\n\n  & > div:first-child,\n  & > span:first-child,\n  & > div:last-child {\n    flex-grow: 0;\n    flex-shrink: 0;\n  }\n\n  ",
        " {\n    border-radius: ",
        ";\n    height: auto;\n    max-height: ",
        ";\n  }\n\n  @media print {\n    height: auto;\n    max-height: auto;\n  }\n"
    ]);
    ProjectQuickView_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProjectQuickView_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    ProjectQuickView_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProjectQuickView_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n\n  padding-bottom: var(--size-3);\n\n  ",
        " {\n    justify-content: space-between;\n    padding-bottom: 0;\n  }\n\n  ",
        "\n"
    ]);
    ProjectQuickView_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProjectQuickView_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  // padding-top: var(--size-3);\n  align-self: flex-start;\n  a {\n    color: var(--color-piai-map-highlight) !important;\n    border-color: var(--color-piai-map-highlight);\n\n    &:visited {\n      color: var(--color-piai-map-highlight);\n    }\n  }\n\n  ",
        " {\n    justify-content: flex-start;\n\n    a {\n      margin-left: 0;\n      &:hover {\n        margin-left: -0.3em;\n      }\n    }\n  }\n"
    ]);
    ProjectQuickView_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProjectQuickView_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  overflow-y: auto;\n\n  & > * {\n    margin-bottom: var(--size-3) !important;\n  }\n"
    ]);
    ProjectQuickView_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}















var DraggableDrawer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(918), __webpack_require__.e(691)]).then(__webpack_require__.bind(__webpack_require__, 2691));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2691)
            ];
        }
    },
    suspense: true
});
var QuickView = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eab38ae0-0"
})(ProjectQuickView_templateObject(), function(param) {
    var isFilterOpen = param.isFilterOpen;
    return isFilterOpen ? "translateX(calc((100vw - var(--size-6) - var(--size-5) - 3 * var(--size-3)) * 0.333))" : "translateX(0)";
}, function(param) {
    var isDirectory = param.isDirectory, theme = param.theme, isFilterOpen = param.isFilterOpen;
    return isDirectory ? "\n    max-height: 100%;\n\n    ".concat(theme.breakpoints.tabletLandscape, " {\n      bottom: ").concat("".concat(isDirectory ? "auto" : "0"), ";\n      top: ").concat("".concat(isDirectory ? "var(--size-3)" : "auto"), ";\n      padding-bottom: ").concat("".concat(isDirectory ? "0" : "var(--size-3)"), ";\n      max-height: ").concat("".concat(isDirectory ? "calc(100vh - var(--lbh) - 2 * var(--size-3))" : "75vh"), ";\n      height: ").concat("".concat(isDirectory ? "calc(100vh - var(--lbh) - var(--size-3))" : "auto"), ";\n      transform: ").concat(isFilterOpen ? "translateX(calc(var(--size-3) + ((100vw - var(--size-6) - var(--size-5) - 3 * var(--size-3)) * 0.666)))" : "translateX(calc(var(--size-3) + ((100vw - var(--size-6) - var(--size-5) - 3 * var(--size-3)) * 0.5)))", ";\n\n      width: ").concat(isFilterOpen ? "calc((100vw - var(--size-6) - var(--size-5) - 3 * var(--size-3)) * 0.333)" : "calc((100vw - var(--size-6) - var(--size-5) - 3 * var(--size-3)) * 0.5)", ";\n    }\n  ") : "";
});
var ProjectQuickView_Panel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eab38ae0-1"
})(ProjectQuickView_templateObject1(), function(param) {
    var isFullHeight = param.isFullHeight;
    return isFullHeight ? "calc(100vh - var(--lbh, 0) - var(--size-5))" : "calc(50vh - (0.5 * var(--lbh, 0)) - var(--size-5))";
}, function(param) {
    var isRefetching = param.isRefetching;
    return isRefetching ? 0.5 : 1;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var isDirectory = param.isDirectory;
    return isDirectory ? "var(--size-3)" : "0";
}, function(param) {
    var isDirectory = param.isDirectory;
    return isDirectory ? "100%" : "75vh";
});
var ProjectQuickView_Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eab38ae0-2"
})(ProjectQuickView_templateObject2());
var ProjectQuickView_Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eab38ae0-3"
})(ProjectQuickView_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("noPrint");
});
var ViewMore = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eab38ae0-4"
})(ProjectQuickView_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
});
var QVScroller = (0,styled_components_browser_esm/* default */.ZP)(Styled/* Scroller */.Tt).withConfig({
    componentId: "sc-eab38ae0-5"
})(ProjectQuickView_templateObject5());
var ProjectQuickView = function(param) {
    var id = param.id, view = param.view;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var isTabletLandscapeAndUp = (0,CssVarsState/* useCssVarsStateIsTabletLandscapeAndUpState */.Xb)();
    var filterState = (0,ToolState/* useToolStateFilterState */.QL)();
    var updateFilterState = (0,ToolState/* useToolStateStoreActions */.cH)().updateFilterState;
    var ref8 = (0,react.useState)(false), isDrawerFullHeight = ref8[0], setIsDrawerFullHeight = ref8[1];
    var ref9 = (0,useQuery/* useQuery */.a)([
        "project-quickview",
        id
    ], function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var signal;
            return (0,tslib_es6.__generator)(this, function(_state) {
                signal = param.signal;
                return [
                    2,
                    fetch("".concat(config/* appConfig.cmsUrl */.e.cmsUrl, "/map/detail/").concat(id), {
                        // Pass the signal to one fetch
                        signal: signal
                    }).then(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            response.json()
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                }
                            });
                        });
                        return function(response) {
                            return _ref.apply(this, arguments);
                        };
                    }())
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        keepPreviousData: true
    }), isLoading = ref9.isLoading, isSuccess = ref9.isSuccess, isRefetching = ref9.isRefetching, data = ref9.data, isError = ref9.isError;
    var hasContent = isSuccess && (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.id);
    console.log(hasContent);
    (0,react.useEffect)(function() {
        updateFilterState({
            isDrawerOpen: hasContent
        });
    }, [
        hasContent,
        updateFilterState
    ]);
    if (!id || isError) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (hasContent) content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectQuickView_Panel, {
        isDirectory: view === "directory",
        isLoading: isLoading,
        isRefetching: isRefetching,
        isFullHeight: !isTabletLandscapeAndUp && isDrawerFullHeight,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectQuickView_Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.acf) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.details) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.nameOfProject) === null || ref4 === void 0 ? void 0 : ref4.value)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QVScroller, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectCard/* ProjectCard */.t, {
                    view: "quickview",
                    data: data === null || data === void 0 ? void 0 : (ref5 = data.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.acf) === null || ref6 === void 0 ? void 0 : ref6.details
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectQuickView_Footer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMore, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/tool/map/project/".concat(data === null || data === void 0 ? void 0 : (ref7 = data.data) === null || ref7 === void 0 ? void 0 : ref7.slug),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* LinkButtonAnimated */.kz, {
                                children: "View full project profile"
                            })
                        })
                    }),
                    isTabletLandscapeAndUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        onClick: function() {
                            updateFilterState({
                                isDrawerOpen: false,
                                quickViewProjectId: null
                            });
                        },
                        type: "back",
                        className: "textLink back inBox",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Close"
                        })
                    })
                ]
            })
        ]
    });
    if (!isTabletLandscapeAndUp && hasContent) content = /*#__PURE__*/ (0,jsx_runtime.jsx)(DraggableDrawer, {
        onFullHeightChange: setIsDrawerFullHeight,
        children: content
    });
    if (isTabletLandscapeAndUp && hasContent) content = /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickView, {
        isFilterOpen: filterState.isFilterOpen || view !== "directory" && filterState.isSearchOpen,
        isDirectory: view === "directory",
        children: content
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Suspense, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* LoadingBar */.F, {
            isLoading: true
        }),
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* LoadingBar */.F, {
                isLoading: isLoading
            }),
            content
        ]
    });
};

;// CONCATENATED MODULE: ./components/tools/map/SearchItem.tsx

function SearchItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-bottom: var(--size-3);\n  width: 100%;\n\n  color: #fff;\n\n  text-align: left;\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  p {\n    font-weight: 700;\n  }\n\n\n  // & > span {\n  //   display: flex;\n  //   flex-direction: row;\n  //   gap: var(--size-2);\n  //   width: 100%;\n  //   margin: 0;\n  //   padding: 0;\n  //   font-size: var(--text-small-font-size);\n  //   overflow: hidden;\n  //   text-overflow: ellipsis;\n  //   white-space: nowrap;\n  // }\n"
    ]);
    SearchItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Item = (0,styled_components_browser_esm/* default */.ZP)(Button/* ButtonNormalized */.lr).withConfig({
    componentId: "sc-ef00fa6-0"
})(SearchItem_templateObject());
var SearchItem = function(param) {
    var feature = param.feature, openQuickView = param.openQuickView;
    var ref, ref1, ref2, ref3, ref4;
    var ref5, ref6, ref7, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
        onClick: function() {
            openQuickView(feature);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: (0,sanitize/* default */.Z)((ref5 = feature === null || feature === void 0 ? void 0 : (ref = feature.properties) === null || ref === void 0 ? void 0 : ref.name) !== null && ref5 !== void 0 ? ref5 : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled/* Meta */.h_, {
                col: 2,
                nowrap: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Icon/* Icon */.J, {
                        type: "marker",
                        stc: true,
                        children: [
                            (0,sanitize/* default */.Z)((ref6 = feature === null || feature === void 0 ? void 0 : (ref1 = feature.properties) === null || ref1 === void 0 ? void 0 : ref1.city) !== null && ref6 !== void 0 ? ref6 : ""),
                            ",",
                            " ",
                            (0,sanitize/* default */.Z)((ref7 = feature === null || feature === void 0 ? void 0 : (ref2 = feature.properties) === null || ref2 === void 0 ? void 0 : ref2.country) !== null && ref7 !== void 0 ? ref7 : "")
                        ]
                    }),
                    ((ref8 = feature === null || feature === void 0 ? void 0 : (ref3 = feature.properties) === null || ref3 === void 0 ? void 0 : ref3.organisation) !== null && ref8 !== void 0 ? ref8 : "").trim() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        type: "company",
                        stc: true,
                        children: (0,sanitize/* default */.Z)(feature === null || feature === void 0 ? void 0 : (ref4 = feature.properties) === null || ref4 === void 0 ? void 0 : ref4.organisation)
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useIsMounted.tsx
var useIsMounted = __webpack_require__(9039);
// EXTERNAL MODULE: ./components/styled/InputText.tsx
var InputText = __webpack_require__(5580);
;// CONCATENATED MODULE: ./components/tools/map/SearchForm.tsx

function SearchForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-bottom: var(--size-3);\n  width: 100%;\n\n  ",
        "\n"
    ]);
    SearchForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // ",
        "\n  font-family: var(--font-family-monospace);\n  text-transform: none;\n  background-color: transparent;\n  color: #fff;\n  width: 100%;\n  margin: 0;\n  border-bottom: 1px solid\n    ",
        ";\n  padding-bottom: 5px;\n  padding-left: calc(var(--size-1) + var(--size-3));\n\n  &::placeholder {\n    color: var(--color-light-grey) !important;\n    font-family: var(--font-family-monospace);\n  }\n"
    ]);
    SearchForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: var(--size-3);\n  height: var(--size-3);\n\n  position: absolute;\n  display: inline-block;\n  top: 50%;\n  transform: translateY(-50%);\n\n  &.searchIcon{\n    left: 0;\n    .svg{\n      max-height: 80%;\n    }\n  }\n\n  &.resetSearch{\n    right: 0;\n  }\n"
    ]);
    SearchForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-99d3a3ac-0"
})(SearchForm_templateObject(), function(param) {
    var theme = param.theme;
    return theme.applyMixin("noPrint");
});
var SearchForm_Input = (0,styled_components_browser_esm/* default */.ZP)(InputText/* default */.Z).withConfig({
    componentId: "sc-99d3a3ac-1"
})(SearchForm_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.textStyle("h3", true);
}, function(param) {
    var isError = param.isError;
    return isError ? "var(--color-ailab-red)" : "#fff";
});
var SearchForm_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* ButtonNormalized */.lr).withConfig({
    componentId: "sc-99d3a3ac-2"
})(SearchForm_templateObject2());
var SearchForm = function(param) {
    var onSubmit = param.onSubmit, onChange = param.onChange, onResetClick = param.onResetClick, isError = param.isError, keyword = param.keyword;
    var inputRef = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
        action: "/",
        onSubmit: function(e) {
            e.preventDefault();
            onSubmit(inputRef.current.value);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_Button, {
                "aria-label": "search",
                type: "submit",
                className: "searchIcon",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolSvgBackground/* ToolSvgBackground */.V, {
                    type: "search"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_Input, {
                isError: isError,
                placeholder: "Search project titles",
                ref: inputRef,
                onChange: function(e) {
                    onChange(e.target.value);
                }
            }),
            keyword !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_Button, {
                type: "reset",
                "aria-label": "reset search",
                className: "resetSearch",
                onClick: function() {
                    inputRef.current.value = "";
                    onResetClick();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolSvgBackground/* ToolSvgBackground */.V, {
                    type: "close"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tools/map/Search.tsx









var Search = function(param) {
    var view = param.view, addCounterPadding = param.addCounterPadding;
    var ref;
    var isMounted = (0,useIsMounted/* default */.Z)();
    var isTabletLandscapeAndUp = (0,CssVarsState/* useCssVarsStateIsTabletLandscapeAndUpState */.Xb)();
    var mapState = (0,ToolState/* useToolStateMapState */.e1)();
    var filterState = (0,ToolState/* useToolStateFilterState */.QL)();
    var ref1 = (0,ToolState/* useToolStateStoreActions */.cH)(), updateMapState = ref1.updateMapState, updateFilterState = ref1.updateFilterState;
    var workerRef = (0,react.useRef)();
    var currentShownKeywordRef = (0,react.useRef)("");
    var ref2 = (0,react.useState)([]), searchResult = ref2[0], setSearchResult = ref2[1];
    var ref3 = (0,react.useState)(""), keyword = ref3[0], setKeyword = ref3[1];
    var ref4 = (0,react.useState)(false), isSearching = ref4[0], setIsSearching = ref4[1];
    var ref5 = (0,react.useState)(false), isError = ref5[0], setIsError = ref5[1];
    var onWorkerMessage = (0,react.useCallback)(function(e) {
        var ref;
        if (!isMounted) return;
        if ((e === null || e === void 0 ? void 0 : (ref = e.data) === null || ref === void 0 ? void 0 : ref.s) === currentShownKeywordRef.current) {
            var ref1;
            setIsSearching(false);
            var ref2;
            setSearchResult((ref2 = e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.result) !== null && ref2 !== void 0 ? ref2 : []);
        }
    }, [
        isMounted
    ]);
    (0,react.useEffect)(function() {
        workerRef.current = new Worker(__webpack_require__.tu(new URL(/* worker import */ __webpack_require__.p + __webpack_require__.u(387), __webpack_require__.b)));
        workerRef.current.onmessage = onWorkerMessage;
        return function() {
            if (workerRef.current) workerRef.current.terminate();
        };
    }, [
        onWorkerMessage
    ]);
    (0,react.useEffect)(function() {
        if (filterState.isSearchOpen && !mapState.geoJson) {
            updateMapState({
                loadGeoJson: true
            });
        }
    }, [
        filterState.isSearchOpen,
        mapState.geoJson,
        updateMapState
    ]);
    var openQuickView = (0,react.useCallback)(function(feature) {
        var ref, ref1;
        if (!(feature === null || feature === void 0 ? void 0 : (ref = feature.properties) === null || ref === void 0 ? void 0 : ref.id)) return;
        if (view === "map" && (mapState === null || mapState === void 0 ? void 0 : (ref1 = mapState.mapController) === null || ref1 === void 0 ? void 0 : ref1.map)) {
            var ref2;
            mapState.mapController.showQuickView(feature.geometry.coordinates, feature === null || feature === void 0 ? void 0 : (ref2 = feature.properties) === null || ref2 === void 0 ? void 0 : ref2.id, !isTabletLandscapeAndUp ? false : true);
        } else {
            var ref3;
            updateFilterState({
                quickViewProjectId: feature === null || feature === void 0 ? void 0 : (ref3 = feature.properties) === null || ref3 === void 0 ? void 0 : ref3.id
            });
        }
    }, [
        isTabletLandscapeAndUp,
        updateFilterState,
        mapState.mapController,
        view
    ]);
    (0,react.useEffect)(function() {
        if ( false || !mapState.geoJson || !workerRef.current) return;
        if (keyword.length > 2) {
            if (keyword !== currentShownKeywordRef.current) {
                if (workerRef.current) {
                    currentShownKeywordRef.current = keyword;
                    workerRef.current.postMessage({
                        s: keyword,
                        geoJson: mapState.geoJson
                    });
                    setIsSearching(true);
                }
            }
        } else {
            currentShownKeywordRef.current = "";
            setSearchResult(null);
        }
    }, [
        mapState.geoJson,
        keyword
    ]);
    var hasNoResults = keyword.length > 2 && (searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) === 0;
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* LoadingBar */.F, {
                isLoading: !mapState.geoJson || isSearching
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarDrawer, {
                columnWidth: 0.333,
                statusFlagKey: "isSearchOpen",
                title: "Project search",
                dimmContent: isSearching,
                addCounterPadding: addCounterPadding,
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {
                    isError: isError,
                    keyword: keyword,
                    onSubmit: function(value) {
                        setKeyword(value);
                        if ((value === null || value === void 0 ? void 0 : value.length) < 3) setIsError(true);
                    },
                    onChange: function(value) {
                        setKeyword(value);
                        setIsError(false);
                    },
                    onResetClick: function() {
                        setKeyword("");
                    }
                }),
                children: [
                    hasNoResults && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "No projects found"
                    }),
                    !hasNoResults && ((ref6 = searchResult !== null && searchResult !== void 0 ? searchResult : mapState === null || mapState === void 0 ? void 0 : (ref = mapState.geoJson) === null || ref === void 0 ? void 0 : ref.features) !== null && ref6 !== void 0 ? ref6 : []).map(function(feature, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchItem, {
                            feature: feature,
                            openQuickView: openQuickView
                        }, "search-".concat(index));
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tools/map/MapOverlays.tsx

function MapOverlays_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 3;\n  pointer-events: none;\n\n  *::selection {\n    background: #fff !important;\n    color: #000 !important;\n  }\n"
    ]);
    MapOverlays_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var MapOverlays_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a739631-0"
})(MapOverlays_templateObject());
var MapOverlays = function() {
    var filterState = (0,ToolState/* useToolStateFilterState */.QL)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapOverlays_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
                view: "map",
                addCounterPadding: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MapFilter, {}),
            (filterState === null || filterState === void 0 ? void 0 : filterState.quickViewProjectId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectQuickView, {
                id: filterState.quickViewProjectId,
                view: "map"
            }, "map-qv-".concat(filterState.quickViewProjectId)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Counter, {
                view: "map"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tools/map/DirectoryFilter.tsx



var DirectoryFilter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarDrawer, {
        columnWidth: 0.333,
        statusFlagKey: "isFilterOpen",
        title: "Project filter",
        initiallyOpenOnLargerScreens: true,
        hasTopOffset: false,
        addCounterPadding: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterContent, {
            view: "directory"
        })
    });
};

;// CONCATENATED MODULE: ./hooks/useEffectOnMountOnce.tsx

var useEffectOnMountOnce = function(effect, dependencies) {
    var effectFn = (0,react.useRef)(effect);
    var destroyFn = (0,react.useRef)();
    var effectCalled = (0,react.useRef)(false);
    var rendered = (0,react.useRef)(false);
    var ref = (0,react.useState)(0), setVal = ref[1];
    if (effectCalled.current) {
        rendered.current = true;
    }
    (0,react.useEffect)(function() {
        // only execute the effect first time around
        if (!effectCalled.current) {
            destroyFn.current = effectFn.current();
            effectCalled.current = true;
        }
        // this forces one render after the effect is run
        setVal(function(val) {
            return val + 1;
        });
        return function() {
            // if the comp didn't render since the useEffect was called,
            // we know it's the dummy React cycle
            if (!rendered.current) {
                return;
            }
            // otherwise this is not a dummy destroy, so call the destroy func
            if (destroyFn.current) {
                destroyFn.current();
            }
        };
    }, []);
};

// EXTERNAL MODULE: ./components/tools/shared/ui/Box.tsx
var Box = __webpack_require__(8695);
// EXTERNAL MODULE: ./components/tools/map/ui/IconButtonPrint.tsx
var IconButtonPrint = __webpack_require__(19);
;// CONCATENATED MODULE: ./components/tools/map/DirectoryList.tsx



function DirectoryList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: var(--size-3);\n  left: var(--size-3);\n  z-index: 4;\n  height: calc(100vh - var(--lbh) - 2 * var(--size-3));\n\n  overflow: hidden;\n  transition: transform 0.35s, width 0.35s;\n  width: calc((100vw - 2 * var(--size-3)));\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-3);\n\n  h1 {\n    flex: calc(var(--size-3) + var(--size-6)) 0 0;\n    display: flex;\n    margin: 0;\n    margin-left: calc(2 * var(--size-3) + var(--size-6));\n    height: var(--size-6);\n    align-items: center;\n\n    ",
        "\n    font-weight: bold;\n    word-spacing: 10000000px;\n\n    ",
        " {\n      display: none;\n    }\n  }\n\n  ",
        " {\n    bottom: 0;\n    left: calc(var(--size-3) + var(--size-6));\n    height: calc(100vh - var(--lbh));\n    width: calc((100vw - var(--size-6) - var(--size-5) - 2 * var(--size-3)));\n    padding-top: var(--size-3);\n    padding-bottom: var(--size-3);\n  }\n\n  ",
        " {\n    width: ",
        ";\n    transform: ",
        ";\n  }\n\n  @media print {\n    position: static;\n    width: 100%;\n    height: auto;\n    overflow: visible;\n    transform: none;\n  }\n"
    ]);
    DirectoryList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DirectoryList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: var(--size-3);\n  flex-wrap: wrap;\n  align-items: center;\n  padding-right: var(--size-6);\n\n  h3 {\n    margin: 0;\n  }\n\n  ",
        " {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--size-2);\n    padding-right: 0;\n  }\n"
    ]);
    DirectoryList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DirectoryList_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  box-sizing: border-box;\n  background: #000;\n  pointer-events: all;\n  padding: var(--size-3);\n  border-radius: var(--size-3);\n  height: ",
        ";\n\n  flex-grow: ",
        ";\n  flex-shrink: ",
        ";\n\n  & > div {\n    flex-grow: 1;\n    transition: opacity var(--transition-speed-link);\n    opacity: ",
        ";\n  }\n\n  & > div:first-child,\n  & > span:first-child {\n    flex-grow: 0;\n    flex-shrink: 0;\n  }\n\n  ",
        " {\n    // height: 50vh;\n    flex: 100%;\n    // gap: var(--size-3);\n  }\n"
    ]);
    DirectoryList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DirectoryList_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: var(--size-3);\n\n  & .print {\n    display: none;\n\n    ",
        " {\n      display: block;\n    }\n  }\n"
    ]);
    DirectoryList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DirectoryList_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  // Overflow on firefox in directory view\n  // height: 50vw;\n  flex: 100%;\n  overflow: hidden;\n"
    ]);
    DirectoryList_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
















var DirectoryList_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d740cb54-0"
})(DirectoryList_templateObject(), function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var isFilterOpen = param.isFilterOpen;
    return isFilterOpen ? "calc((100vw - var(--size-6) - var(--size-5) - 3 * var(--size-3)) * 0.333)" : "calc((100vw - var(--size-6) - var(--size-5) - 3 * var(--size-3)) * 0.5)";
}, function(param) {
    var isFilterOpen = param.isFilterOpen;
    return isFilterOpen ? "translateX(calc((100vw - var(--size-6) - var(--size-5) - 3 * var(--size-3)) * 0.333))" : "translateX(0)";
});
var DirectoryList_Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d740cb54-1"
})(DirectoryList_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var DirectoryList_Panel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d740cb54-2"
})(DirectoryList_templateObject2(), function(param) {
    var isFullHeight = param.isFullHeight;
    return isFullHeight ? "calc(100vh - var(--lbh, 0) - var(--size-5))" : "200px";
}, function(param) {
    var isFullHeight = param.isFullHeight;
    return isFullHeight ? 0 : 1;
}, function(param) {
    var isFullHeight = param.isFullHeight;
    return isFullHeight ? 0 : 1;
}, function(param) {
    var isRefetching = param.isRefetching;
    return isRefetching ? 0.5 : 1;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
});
var Toolbar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d740cb54-3"
})(DirectoryList_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var ScrollerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d740cb54-4"
})(DirectoryList_templateObject4());
var DirectoryList = function() {
    var ref;
    var searchFieldId = (0,react.useId)();
    var router = (0,next_router.useRouter)();
    var isMounted = (0,useIsMounted/* default */.Z)();
    var mapState = (0,ToolState/* useToolStateMapState */.e1)();
    var filterState = (0,ToolState/* useToolStateFilterState */.QL)();
    var ref1 = (0,ToolState/* useToolStateStoreActions */.cH)(), updateFilterState = ref1.updateFilterState, getDefaultState = ref1.getDefaultState;
    var isTabletLandscapeAndUp = (0,CssVarsState/* useCssVarsStateIsTabletLandscapeAndUpState */.Xb)();
    var currentlyRenderedQueryStringRef = (0,react.useRef)();
    var filterWorkerRef = (0,react.useRef)();
    var searchWorkerRef = (0,react.useRef)();
    var currentShownKeywordRef = (0,react.useRef)("");
    var ref2 = (0,react.useState)(null), searchResult = ref2[0], setSearchResult = ref2[1];
    var ref3 = (0,react.useState)(false), isFiltering = ref3[0], setIsFiltering = ref3[1];
    var ref4 = (0,react.useState)(""), keyword = ref4[0], setKeyword = ref4[1];
    var ref5 = (0,react.useState)(false), isError = ref5[0], setIsError = ref5[1];
    var openQuickView = (0,react.useCallback)(function(feature) {
        var ref, ref1;
        if (!(feature === null || feature === void 0 ? void 0 : (ref = feature.properties) === null || ref === void 0 ? void 0 : ref.id)) return;
        updateFilterState({
            quickViewProjectId: feature === null || feature === void 0 ? void 0 : (ref1 = feature.properties) === null || ref1 === void 0 ? void 0 : ref1.id
        });
    }, [
        updateFilterState
    ]);
    var onFilterWorkerMessage = (0,react.useCallback)(function(e) {
        var ref;
        if (!isMounted) return;
        setIsFiltering(false);
        var ref1;
        setSearchResult((ref1 = e === null || e === void 0 ? void 0 : (ref = e.data) === null || ref === void 0 ? void 0 : ref.result) !== null && ref1 !== void 0 ? ref1 : []);
    }, [
        isMounted
    ]);
    var onSearchWorkerMessage = (0,react.useCallback)(function(e) {
        var ref;
        if (!isMounted) return;
        setIsFiltering(false);
        var ref1;
        setSearchResult((ref1 = e === null || e === void 0 ? void 0 : (ref = e.data) === null || ref === void 0 ? void 0 : ref.result) !== null && ref1 !== void 0 ? ref1 : []);
    }, [
        isMounted
    ]);
    useEffectOnMountOnce(function() {
        filterWorkerRef.current = new Worker(__webpack_require__.tu(new URL(/* worker import */ __webpack_require__.p + __webpack_require__.u(653), __webpack_require__.b)));
        searchWorkerRef.current = new Worker(__webpack_require__.tu(new URL(/* worker import */ __webpack_require__.p + __webpack_require__.u(43), __webpack_require__.b)));
        filterWorkerRef.current.onmessage = onFilterWorkerMessage;
        searchWorkerRef.current.onmessage = onSearchWorkerMessage;
        return function() {
            if (filterWorkerRef.current) {
                filterWorkerRef.current.terminate();
            }
            if (searchWorkerRef.current) {
                searchWorkerRef.current.terminate();
            }
        };
    }, [
        onFilterWorkerMessage,
        onSearchWorkerMessage
    ]);
    var maybeUpdateQueryString = (0,react.useCallback)(function(state) {
        var newQueryString = (0,utils/* createCompareQueryFromState */.zu)(state);
        var _search;
        if (newQueryString !== ((_search = document.location.search) !== null && _search !== void 0 ? _search : "").replace("&empty=1", "")) {
            router.push({
                pathname: router.pathname,
                search: newQueryString !== "" ? newQueryString : "?empty=1"
            }, undefined, {
                shallow: true
            });
        }
    }, [
        router
    ]);
    var currentQueryString = (0,utils/* createCompareQueryFromState */.zu)(filterState);
    (0,react.useEffect)(function() {
        if ( false || !mapState.geoJson) return;
        if (!filterState.isSearchOpen) {
            currentShownKeywordRef.current = "";
            if (filterWorkerRef.current && Array.isArray(filterState.filteredIds) && currentQueryString !== "") {
                if (filterState.filterQueryString !== currentlyRenderedQueryStringRef.current) {
                    currentlyRenderedQueryStringRef.current = filterState.filterQueryString;
                    filterWorkerRef.current.postMessage({
                        ids: filterState.filteredIds,
                        geoJson: mapState.geoJson
                    });
                    setIsFiltering(true);
                }
            } else {
                setSearchResult(null);
            }
        } else {
            currentlyRenderedQueryStringRef.current = "";
            if (searchWorkerRef.current && keyword.length > 2) {
                if (keyword !== currentShownKeywordRef.current) {
                    if (searchWorkerRef.current) {
                        currentShownKeywordRef.current = keyword;
                        searchWorkerRef.current.postMessage({
                            s: keyword,
                            geoJson: mapState.geoJson
                        });
                        maybeUpdateQueryString((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), {
                            isSearchOpen: true,
                            keyword: keyword
                        }));
                        setIsFiltering(true);
                    }
                }
            } else {
                currentShownKeywordRef.current = "";
                setSearchResult(null);
            }
        }
    }, [
        filterState,
        filterState.isSearchOpen,
        filterState.filteredIds,
        filterState.filterQueryString,
        keyword,
        getDefaultState,
        maybeUpdateQueryString,
        currentQueryString,
        mapState.geoJson, 
    ]);
    var hasNoResults = (searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) === 0;
    var count = filterState.totalCount;
    if (filterState.isSearchOpen) {
        var ref6;
        count = (ref6 = searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) !== null && ref6 !== void 0 ? ref6 : filterState.totalCount;
    } else {
        if (filterState.filterQueryString) {
            count = filterState.filteredCount;
        }
    }
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DirectoryList_Container, {
        isFilterOpen: filterState.isFilterOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Project Directory"
            }),
            isTabletLandscapeAndUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                hideOnPrint: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar, {
                    children: [
                        !filterState.isSearchOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: function() {
                                return updateFilterState({
                                    isFilterOpen: true
                                });
                            },
                            children: [
                                "FILTERED ",
                                count,
                                "/",
                                filterState.totalCount
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            onClick: function() {
                                return filterState.isSearchOpen ? updateFilterState({
                                    isSearchOpen: false,
                                    isFilterOpen: true
                                }) : updateFilterState({
                                    isFilterOpen: true
                                });
                            },
                            type: "filter",
                            spaceBefore: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            onClick: function() {
                                return updateFilterState({
                                    isSearchOpen: true
                                });
                            },
                            type: "search"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonPrint/* IconButtonPrint */.V, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DirectoryList_Panel, {
                isRefetching: isFiltering || filterState.isFetchingFilteredIds,
                isFullHeight: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DirectoryList_Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled/* Label */.__, {
                                children: "Project directory"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reveal/* Reveal */.U, {
                                id: searchFieldId,
                                role: "region",
                                open: filterState.isSearchOpen,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {
                                    isError: isError,
                                    keyword: keyword,
                                    onSubmit: function(value) {
                                        setKeyword(value);
                                        if ((value === null || value === void 0 ? void 0 : value.length) < 3) {
                                            maybeUpdateQueryString((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getDefaultState().filter), {
                                                isSearchOpen: true,
                                                keyword: ""
                                            }));
                                            setIsError(true);
                                        }
                                    },
                                    onChange: function(value) {
                                        setKeyword(value);
                                        setIsError(false);
                                    },
                                    onResetClick: function() {
                                        maybeUpdateQueryString((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getDefaultState().filter), {
                                            isSearchOpen: true,
                                            keyword: ""
                                        }));
                                        setKeyword("");
                                        setIsFiltering(false);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollerContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled/* Scroller */.Tt, {
                            opacity: 1,
                            children: [
                                hasNoResults && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "No projects found"
                                }),
                                !hasNoResults && ((ref7 = searchResult !== null && searchResult !== void 0 ? searchResult : mapState === null || mapState === void 0 ? void 0 : (ref = mapState.geoJson) === null || ref === void 0 ? void 0 : ref.features) !== null && ref7 !== void 0 ? ref7 : []).map(function(feature, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchItem, {
                                        feature: feature,
                                        openQuickView: openQuickView
                                    }, "search-".concat(index));
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tools/map/DirectoryOverlays.tsx

function DirectoryOverlays_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 3;\n  pointer-events: none;\n\n  *::selection {\n    background: #fff !important;\n    color: #000 !important;\n  }\n\n"
    ]);
    DirectoryOverlays_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var DirectoryOverlays_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4d4cb1cf-0"
})(DirectoryOverlays_templateObject());
var DirectoryOverlays = function() {
    var filterState = (0,ToolState/* useToolStateFilterState */.QL)();
    var updateMapState = (0,ToolState/* useToolStateStoreActions */.cH)().updateMapState;
    (0,react.useEffect)(function() {
        updateMapState({
            loadGeoJson: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DirectoryOverlays_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryFilter, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryList, {}),
            (filterState === null || filterState === void 0 ? void 0 : filterState.quickViewProjectId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectQuickView, {
                id: filterState.quickViewProjectId,
                view: "directory"
            }, "directory-qv-".concat(filterState.quickViewProjectId)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Counter, {
                view: "directory"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tools/map/state/ToolStateController.tsx









var fetchSettings = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var signal;
        return (0,tslib_es6.__generator)(this, function(_state) {
            signal = param.signal;
            return [
                2,
                fetch("".concat(config/* appConfig.apiUrl */.e.apiUrl, "/fluxed/v1/piai/filter"), {
                    // Pass the signal to one fetch
                    signal: signal
                }).then(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        response.json()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                            }
                        });
                    });
                    return function(response) {
                        return _ref.apply(this, arguments);
                    };
                }())
            ];
        });
    });
    return function fetchSettings(_) {
        return _ref.apply(this, arguments);
    };
}();
var fetchGeoJson = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var signal, ref, ref1, ref2, mapTool;
        return (0,tslib_es6.__generator)(this, function(_state) {
            signal = param.signal;
            mapTool = (ref = config/* appConfig.tools */.e.tools) === null || ref === void 0 ? void 0 : ref.find(function(t) {
                return t.slug === "map";
            });
            if (!(mapTool === null || mapTool === void 0 ? void 0 : (ref1 = mapTool.config) === null || ref1 === void 0 ? void 0 : ref1.urlGeoJson)) return [
                2,
                null
            ];
            return [
                2,
                fetch("".concat(config/* appConfig.cmsUrl */.e.cmsUrl).concat(mapTool === null || mapTool === void 0 ? void 0 : (ref2 = mapTool.config) === null || ref2 === void 0 ? void 0 : ref2.urlGeoJson), {
                    // Pass the signal to one fetch
                    signal: signal
                }).then(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        response.json()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                            }
                        });
                    });
                    return function(response) {
                        return _ref.apply(this, arguments);
                    };
                }())
            ];
        });
    });
    return function fetchGeoJson(_) {
        return _ref.apply(this, arguments);
    };
}();
var fetchFilteredQueryIds = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var signal, queryKey, _queryKey, _key, queryString;
        return (0,tslib_es6.__generator)(this, function(_state) {
            signal = param.signal, queryKey = param.queryKey;
            _queryKey = (0,_sliced_to_array/* default */.Z)(queryKey, 2), _key = _queryKey[0], queryString = _queryKey[1].queryString;
            return [
                2,
                fetch("".concat(config/* appConfig.cmsUrl */.e.cmsUrl, "/map/query?").concat(queryString), {
                    // Pass the signal to one fetch
                    signal: signal
                }).then(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        response.json()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                            }
                        });
                    });
                    return function(response) {
                        return _ref.apply(this, arguments);
                    };
                }())
            ];
        });
    });
    return function fetchFilteredQueryIds(_) {
        return _ref.apply(this, arguments);
    };
}();
// context provider
var ToolStateController = function() {
    var stateMap = (0,ToolState/* useToolStateMapState */.e1)();
    var stateFilter = (0,ToolState/* useToolStateFilterState */.QL)();
    var ref = (0,ToolState/* useToolStateStoreActions */.cH)(), updateFilterState = ref.updateFilterState, updateMapState = ref.updateMapState, updateSettingsState = ref.updateSettingsState;
    var queryResultSettings = (0,useQuery/* useQuery */.a)([
        "settings"
    ], fetchSettings);
    var queryResultGeoJson = (0,useQuery/* useQuery */.a)([
        "geojson"
    ], fetchGeoJson, {
        enabled: stateMap.loadGeoJson
    });
    var currentQueryString = (0,utils/* createCompareQueryFromState */.zu)(stateFilter);
    var newFilterIdsQuery = (0,utils/* createQueryFromState */.fy)(stateFilter, {
        onlyIds: "1"
    }, [
        "filter",
        "search",
        "empty",
        "keyword"
    ]);
    var queryFilteredIds = (0,useQuery/* useQuery */.a)([
        "map-filter",
        {
            queryString: newFilterIdsQuery.length > 0 ? newFilterIdsQuery.slice(1) : ""
        }, 
    ], fetchFilteredQueryIds, {
        enabled: ToolState/* defaultCompareQueryString */.ww !== currentQueryString
    });
    if (queryResultSettings.isError) throw "Could not fetch needed data from server.";
    (0,react.useEffect)(function() {
        if (!queryResultSettings.isLoading && queryResultSettings.isSuccess && queryResultSettings.data) {
            (0,react.startTransition)(function() {
                return updateSettingsState(queryResultSettings.data);
            });
        }
    }, [
        queryResultSettings.isLoading,
        queryResultSettings.isSuccess,
        queryResultSettings.data,
        updateSettingsState, 
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!queryResultGeoJson.isLoading && queryResultGeoJson.isSuccess && (queryResultGeoJson === null || queryResultGeoJson === void 0 ? void 0 : (ref = queryResultGeoJson.data) === null || ref === void 0 ? void 0 : ref.type) === "FeatureCollection") {
            (0,react.startTransition)(function() {
                var ref, ref1, ref2, ref3;
                updateMapState({
                    geoJson: queryResultGeoJson.data
                });
                var ref4, ref5;
                updateFilterState({
                    totalCount: (ref4 = (ref = queryResultGeoJson.data) === null || ref === void 0 ? void 0 : (ref1 = ref.features) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref4 !== void 0 ? ref4 : 0,
                    filteredCount: (ref5 = (ref2 = queryResultGeoJson.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.features) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref5 !== void 0 ? ref5 : 0
                });
            });
        }
    }, [
        queryResultGeoJson.isLoading,
        queryResultGeoJson.isSuccess,
        queryResultGeoJson.data,
        updateMapState,
        updateFilterState, 
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!queryFilteredIds.isLoading && !queryFilteredIds.isFetching && queryFilteredIds.isSuccess && Array.isArray(queryFilteredIds === null || queryFilteredIds === void 0 ? void 0 : (ref = queryFilteredIds.data) === null || ref === void 0 ? void 0 : ref.data)) {
            (0,react.startTransition)(function() {
                return updateFilterState({
                    filteredIds: queryFilteredIds.data.data,
                    filteredCount: queryFilteredIds.data.data.length,
                    isFetchingFilteredIds: false,
                    filterQueryString: currentQueryString
                });
            });
        } else if (queryFilteredIds.isFetching) {
            (0,react.startTransition)(function() {
                return updateFilterState({
                    isFetchingFilteredIds: true
                });
            });
        }
    }, [
        queryFilteredIds.isLoading,
        queryFilteredIds.isFetching,
        queryFilteredIds.isSuccess,
        queryFilteredIds.data,
        currentQueryString,
        updateFilterState, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

// EXTERNAL MODULE: ./components/state/PageState.tsx
var PageState = __webpack_require__(5707);
;// CONCATENATED MODULE: ./components/tools/map/Layout.tsx





function Layout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-height: 100%;\n\n  // hier kein padding!\n  // das wird in den page layouts gesetzt\n  // padding: var(--size-3);\n\n  ",
        "\n\n  ",
        " {\n    padding: 0 0 0 var(--size-6);\n  }\n\n  *::selection {\n    background: #fff !important;\n    color: #000 !important;\n  }\n"
    ]);
    Layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



















var Map = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(644), __webpack_require__.e(849), __webpack_require__.e(670)]).then(__webpack_require__.bind(__webpack_require__, 1879));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1879)
            ];
        }
    },
    // suspense: true,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* LoadingBar */.F, {
            isLoading: true
        });
    }
});
// Contains:
// transparent when overlaying map
// contains {children}
var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4671fa3e-0"
})(Layout_templateObject(), function(param) {
    var isTransparent = param.isTransparent;
    return isTransparent ? "\n    background-color: transparent;\n    pointer-events: none;\n    \n    " : "\n      background: var(--color-bg-tool);\n      min-height: calc(100vh - var(--lbh, 0));\n  ";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var isInit = false;
var previousPathName = "";
var Layout = function(param) {
    var children = param.children, props = param.props;
    var router = (0,next_router.useRouter)();
    var config = (0,ConfigContextProvider/* useConfigContext */.q)();
    var isLoading = (0,PageState/* usePageStateIsLoadingState */.YB)();
    var settingsState = (0,ToolState/* useToolStateSettingsState */.wk)();
    var ref = (0,ToolState/* useToolStateStoreActions */.cH)(), updateFilterState = ref.updateFilterState, setFilterState = ref.setFilterState, getDefaultState = ref.getDefaultState;
    var ref1 = (0,react.useState)((props === null || props === void 0 ? void 0 : props.view) === "map"), showMap = ref1[0], setShowMap = ref1[1];
    var isMap = (props === null || props === void 0 ? void 0 : props.view) === "map";
    var isDirectory = router.pathname.indexOf("directory") > -1;
    var updateFromQuery = (0,react.useCallback)(function(isInitCall) {
        if (document.location.search === "") {
            if (!isInitCall) {
                setFilterState(getDefaultState().filter);
            }
        } else if ((settingsState === null || settingsState === void 0 ? void 0 : settingsState.styleUrl) !== "") {
            var newState = {};
            var params = new URLSearchParams(document.location.search);
            var isDirectory = router.pathname.indexOf("directory") > -1;
            var ref;
            var term = (ref = params.get("term")) !== null && ref !== void 0 ? ref : "";
            if (term !== "") {
                var terms = term.split(",");
                var allTerms = [
                    "funding",
                    "industrialSector",
                    "useOfAi",
                    "isProjectOpenSource", 
                ].reduce(function(carry, key) {
                    var ref;
                    var ref1;
                    return (0,_object_spread/* default */.Z)({}, carry, ((ref1 = settingsState === null || settingsState === void 0 ? void 0 : (ref = settingsState[key]) === null || ref === void 0 ? void 0 : ref.options) !== null && ref1 !== void 0 ? ref1 : []).reduce(function(c, term) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, c), (0,_define_property/* default */.Z)({}, term.id, term.name));
                    }, {}));
                }, {});
                newState.terms = terms.reduce(function(carry, termId) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carry), (0,_define_property/* default */.Z)({}, termId, allTerms[termId]));
                }, {});
            } else {
                newState.terms = {};
            }
            var ref1;
            var regions = (ref1 = params.get("regions")) !== null && ref1 !== void 0 ? ref1 : "";
            if (regions !== "" && settingsState.regions && isDirectory) {
                var activeRegions = regions.split(",");
                var flattenRegions = function(regions, carry) {
                    if (!(regions === null || regions === void 0 ? void 0 : regions.length)) return carry;
                    return regions.reduce(function(carry, region) {
                        carry = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carry), (0,_define_property/* default */.Z)({}, region.id, region.name)), region.children.length ? flattenRegions(region.children, {}) : {});
                        return carry;
                    }, carry);
                };
                var allRegions = flattenRegions(settingsState.regions, {});
                newState.regions = activeRegions.reduce(function(carry, regionId) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carry), (0,_define_property/* default */.Z)({}, regionId, allRegions[regionId]));
                }, {});
            } else {
                newState.regions = {};
            }
            [
                "license",
                "genderRatio", 
            ].concat((0,_to_consumable_array/* default */.Z)(isDirectory ? [
                "countries"
            ] : [])).reduce(function(state, key) {
                var ref;
                var ref1;
                var selected = (ref1 = params.get(key)) !== null && ref1 !== void 0 ? ref1 : "";
                if (selected !== "" && (settingsState === null || settingsState === void 0 ? void 0 : (ref = settingsState[key]) === null || ref === void 0 ? void 0 : ref.length)) {
                    var active = selected.split(",");
                    var allTerms = settingsState[key].reduce(function(carry, term) {
                        carry = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carry), (0,_define_property/* default */.Z)({}, term.id, term.name));
                        return carry;
                    }, {});
                    newState[key] = active.reduce(function(carry, id) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carry), (0,_define_property/* default */.Z)({}, id, allTerms[id]));
                    }, {});
                } else {
                    newState[key] = {};
                }
                return state;
            }, newState);
            var ref2;
            var dateFrom = (ref2 = params.get("dateFrom")) !== null && ref2 !== void 0 ? ref2 : "";
            var ref3;
            var dateUntil = (ref3 = params.get("dateUntil")) !== null && ref3 !== void 0 ? ref3 : "";
            if (dateFrom !== "" && dateUntil !== "") {
                newState.dateFrom = dateFrom;
                newState.dateUntil = dateUntil;
            } else {
                newState.dateFrom = null;
                newState.dateUntil = null;
            }
            var search = params.get("search");
            if (search) newState.isSearchOpen = search === "1";
            if (newState === null || newState === void 0 ? void 0 : newState.isSearchOpen) newState.isFilterOpen = false;
            var filter = params.get("filter");
            if (filter) newState.isFilterOpen = filter === "1";
            if (newState === null || newState === void 0 ? void 0 : newState.isFilterOpen) newState.isSearchOpen = false;
            var keyword = params.get("keyword");
            newState.keyword = keyword ? keyword.trim() : "";
            if (Object.keys(newState).length) {
                updateFilterState((0,_object_spread/* default */.Z)({}, newState));
            }
        }
    }, [
        settingsState,
        setFilterState,
        updateFilterState,
        getDefaultState,
        router.pathname
    ]);
    var onRouterChangeComplete = (0,react.useCallback)(function(url) {
        if (previousPathName === document.location.pathname && url.replace("?empty=1", "") !== "") {
            updateFromQuery(false);
        }
        previousPathName = router.pathname;
    }, [
        updateFromQuery,
        router.pathname
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        // bit hacky but as the component is rendered several times we want to make sure to
        // only check the query string once (on load)
        if ((settingsState === null || settingsState === void 0 ? void 0 : settingsState.styleUrl) !== "" && !isInit) {
            updateFromQuery(true);
            isInit = true;
            previousPathName = document.location.pathname;
        }
        router.events.on("routeChangeComplete", onRouterChangeComplete);
        return function() {
            router.events.off("routeChangeComplete", onRouterChangeComplete);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        settingsState === null || settingsState === void 0 ? void 0 : settingsState.styleUrl
    ]);
    (0,react.useEffect)(function() {
        if (isMap && !showMap) {
            setShowMap(true);
        }
    }, [
        isMap,
        showMap
    ]);
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
        isTransparent: isMap,
        children: children
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* default */.Z, {
                title: "".concat(config.appTitle),
                og: {
                    image: "".concat(config.baseUrl, "/img/poster.jpg"),
                    type: "article",
                    siteName: "".concat(config.appTitle)
                },
                twitter: {
                    card: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MatomoUserTracking/* MatomoUserTracking */.b, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* LoadingBar */.F, {
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuButton/* MenuButton */.j, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(context_ReactQueryContextProvider, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolStateController, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar/* Sidebar */.Y, {
                        tool: "map",
                        view: props === null || props === void 0 ? void 0 : props.view,
                        slug: props === null || props === void 0 ? void 0 : props.slug,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Submenu, {
                            tool: "map",
                            slug: props === null || props === void 0 ? void 0 : props.slug
                        })
                    }),
                    showMap && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
                                isMapView: isMap
                            }),
                            isMap && content
                        ]
                    }),
                    !isMap && content,
                    isMap && /*#__PURE__*/ (0,jsx_runtime.jsx)(MapOverlays, {}),
                    isDirectory && /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryOverlays, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu */.v, {})
        ]
    });
};
/* harmony default export */ var map_Layout = (Layout);


/***/ }),

/***/ 7200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ ProjectCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/ui/SafeHtmlDiv.tsx
var SafeHtmlDiv = __webpack_require__(3427);
// EXTERNAL MODULE: ./components/tools/shared/ui/Icon.tsx
var Icon = __webpack_require__(7205);
// EXTERNAL MODULE: ./components/tools/map/Question.tsx
var Question = __webpack_require__(9564);
// EXTERNAL MODULE: ./components/tools/map/Styled.tsx
var Styled = __webpack_require__(503);
;// CONCATENATED MODULE: ./utils/index.ts
var formatDate = function(date, format) {
    if (!date) return "";
    try {
        var d = new Date(date.replace(/ /g, "T"));
        if (d) return d.toLocaleDateString("en-GB", format).replace(/\//g, ".");
    } catch (e) {}
    return "";
};
var dateWeekday = function(date) {
    if (!date) return "";
    try {
        var d = new Date(date.replace(/ /g, "T"));
        if (d) return d.toLocaleDateString("en-GB", {
            weekday: "long"
        });
    } catch (e) {}
    return "";
};
var dateYear = function(date) {
    var defaultToThisYear = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (!date) return null;
    try {
        var d = new Date(date.replace(/ /g, "T"));
        if (d) return d.toLocaleDateString("en-GB", {
            year: "numeric"
        });
    } catch (e) {}
    if (!defaultToThisYear) return null;
    var d1 = new Date();
    return d1.toLocaleDateString("en-GB", {
        year: "numeric"
    });
};

// EXTERNAL MODULE: ./utils/sanitize.ts
var sanitize = __webpack_require__(2938);
;// CONCATENATED MODULE: ./components/tools/map/ProjectCard.tsx








var ProjectCard = function(param) {
    var _view = param.view, view = _view === void 0 ? "detail" : _view, data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38;
    var sourceCode = "Unknown license";
    switch(data === null || data === void 0 ? void 0 : (ref = data.isProjectOpenSource) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.trim().toLowerCase()){
        case "no":
            sourceCode = "Closed source";
            break;
        case "yes":
            sourceCode = "Open source";
            break;
    }
    var genderRatio = [
        "-",
        "-",
        "-"
    ];
    try {
        var ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47;
        if (data === null || data === void 0 ? void 0 : (ref39 = data.teamGenderRatioMale) === null || ref39 === void 0 ? void 0 : ref39.value) genderRatio[0] = (data === null || data === void 0 ? void 0 : (ref40 = data.teamGenderRatioMale) === null || ref40 === void 0 ? void 0 : ref40.value) ? "".concat(parseInt(data === null || data === void 0 ? void 0 : (ref41 = data.teamGenderRatioMale) === null || ref41 === void 0 ? void 0 : ref41.value)) : "-";
        if (data === null || data === void 0 ? void 0 : (ref42 = data.teamGenderRatioFemale) === null || ref42 === void 0 ? void 0 : ref42.value) genderRatio[1] = (data === null || data === void 0 ? void 0 : (ref43 = data.teamGenderRatioFemale) === null || ref43 === void 0 ? void 0 : ref43.value) ? "".concat(parseInt(data === null || data === void 0 ? void 0 : (ref44 = data.teamGenderRatioFemale) === null || ref44 === void 0 ? void 0 : ref44.value)) : "-";
        if (data === null || data === void 0 ? void 0 : (ref45 = data.teamGenderRatioNonBinary) === null || ref45 === void 0 ? void 0 : ref45.value) genderRatio[2] = (data === null || data === void 0 ? void 0 : (ref46 = data.teamGenderRatioNonBinary) === null || ref46 === void 0 ? void 0 : ref46.value) ? "".concat(parseInt(data === null || data === void 0 ? void 0 : (ref47 = data.teamGenderRatioNonBinary) === null || ref47 === void 0 ? void 0 : ref47.value)) : "-";
    } catch (err) {}
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            view !== "quickview" && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref2 = data.nameOfProject) === null || ref2 === void 0 ? void 0 : ref2.value)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled/* Meta */.h_, {
                col: 2,
                nowrap: view == "quickview" ? true : false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Icon/* Icon */.J, {
                        type: "marker",
                        stc: true,
                        children: [
                            (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref3 = data.city) === null || ref3 === void 0 ? void 0 : ref3.value),
                            ", ",
                            (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref4 = data.country) === null || ref4 === void 0 ? void 0 : ref4.value)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        type: "calendar",
                        stc: true,
                        children: formatDate(data === null || data === void 0 ? void 0 : (ref5 = data.projectStartDate) === null || ref5 === void 0 ? void 0 : ref5.value, {
                            year: "numeric",
                            month: "long"
                        })
                    }),
                    (data === null || data === void 0 ? void 0 : (ref6 = data.organisation) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.value) === null || ref7 === void 0 ? void 0 : ref7.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        type: "company",
                        stc: true,
                        children: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref8 = data.organisation) === null || ref8 === void 0 ? void 0 : ref8.value)
                    }),
                    (data === null || data === void 0 ? void 0 : (ref9 = data.size) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.value) === null || ref10 === void 0 ? void 0 : ref10.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Icon/* Icon */.J, {
                        type: "people",
                        stc: true,
                        children: [
                            (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref11 = data.size) === null || ref11 === void 0 ? void 0 : ref11.value),
                            " Team members"
                        ]
                    })
                ]
            }),
            (data === null || data === void 0 ? void 0 : (ref12 = data.shortDescription) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.value) === null || ref13 === void 0 ? void 0 : ref13.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtmlDiv/* default */.Z, {
                html: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref14 = data.shortDescription) === null || ref14 === void 0 ? void 0 : ref14.value)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styled/* Meta */.h_, {
                col: 3,
                nowrap: view == "quickview" ? true : false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        type: "code",
                        stc: true,
                        children: sourceCode
                    }),
                    genderRatio.find(function(val) {
                        return val.toLowerCase() !== "-";
                    }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Icon/* Icon */.J, {
                        type: "genders",
                        stc: true,
                        children: [
                            genderRatio.join("/"),
                            " (% m/f/d)"
                        ]
                    }),
                    (data === null || data === void 0 ? void 0 : (ref15 = data.funding) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.value) === null || ref16 === void 0 ? void 0 : ref16.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        type: "money",
                        stc: true,
                        children: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref17 = data.funding) === null || ref17 === void 0 ? void 0 : ref17.value.join(", "))
                    })
                ]
            }),
            view === "detail" && (data === null || data === void 0 ? void 0 : (ref18 = data.stage) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.value) === null || ref19 === void 0 ? void 0 : ref19.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Question/* Question */.H, {
                question: "Project stage (in ".concat(formatDate(data === null || data === void 0 ? void 0 : data.date, {
                    year: "numeric",
                    month: "long"
                }), "):"),
                showAlways: true,
                children: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref20 = data.stage) === null || ref20 === void 0 ? void 0 : ref20.value)
            }),
            view === "detail" && (data === null || data === void 0 ? void 0 : (ref21 = data.implementedBy) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.value) === null || ref22 === void 0 ? void 0 : ref22.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Question/* Question */.H, {
                question: "Implemented by:",
                showAlways: true,
                children: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref23 = data.implementedBy) === null || ref23 === void 0 ? void 0 : ref23.value.join(", "))
            }),
            (data === null || data === void 0 ? void 0 : (ref24 = data.industrialSector) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.value) === null || ref25 === void 0 ? void 0 : ref25.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Question/* Question */.H, {
                question: "Industrial Sectors:",
                showAlways: true,
                children: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref26 = data.industrialSector) === null || ref26 === void 0 ? void 0 : ref26.value.join(", "))
            }),
            (data === null || data === void 0 ? void 0 : (ref27 = data.useOfAi) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.value) === null || ref28 === void 0 ? void 0 : ref28.length) > 0 && (data === null || data === void 0 ? void 0 : (ref29 = data.useOfAi) === null || ref29 === void 0 ? void 0 : ref29.value) != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Question/* Question */.H, {
                question: "Usage of AI:",
                showAlways: true,
                children: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref30 = data.useOfAi) === null || ref30 === void 0 ? void 0 : ref30.value.join(", "))
            }),
            (data === null || data === void 0 ? void 0 : (ref31 = data.generationMachineLearning) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.value) === null || ref32 === void 0 ? void 0 : ref32.length) > 0 && (data === null || data === void 0 ? void 0 : (ref33 = data.generationMachineLearning) === null || ref33 === void 0 ? void 0 : ref33.value) != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Question/* Question */.H, {
                question: "Generation of AI:",
                showAlways: true,
                children: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref34 = data.generationMachineLearning) === null || ref34 === void 0 ? void 0 : ref34.value.join(", "))
            }),
            (data === null || data === void 0 ? void 0 : (ref35 = data.modelTrainingBuilt) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.value) === null || ref36 === void 0 ? void 0 : ref36.length) > 0 && (data === null || data === void 0 ? void 0 : (ref37 = data.modelTrainingBuilt) === null || ref37 === void 0 ? void 0 : ref37.value) != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Question/* Question */.H, {
                question: "Model training:",
                showAlways: true,
                children: (0,sanitize/* default */.Z)(data === null || data === void 0 ? void 0 : (ref38 = data.modelTrainingBuilt) === null || ref38 === void 0 ? void 0 : ref38.value.join(", "))
            })
        ]
    });
};


/***/ }),

/***/ 9564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ Question; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9521);
/* harmony import */ var _components_ui_SafeHtmlDiv__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3427);
/* harmony import */ var _components_svgs_SvgarrowsExpand__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5102);
/* harmony import */ var _components_svgs_SvgarrowsCollapse__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(533);
/* harmony import */ var _components_ui_Reveal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1663);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  h3 {\n    text-transform: none;\n    margin-bottom: 5px;\n    font-size: inherit;\n    font-weight: 700;\n    cursor: pointer;\n    display: inline-block;\n    padding-right: 1.5em;\n\n    &:hover {\n      opacity: 0.8;\n      background-position: right 0.2em;\n      background-repeat: no-repeat;\n      background-size: 0.8em;\n      background-image: url("data:image/svg+xml,',
        '");\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var QuestionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a0b73253-0"
})(_templateObject(), function(param) {
    var svg = param.svg;
    return svg;
});
var Question = function(param) {
    var question = param.question, _expanded = param.expanded, expanded = _expanded === void 0 ? true : _expanded, _showAlways = param.showAlways, showAlways = _showAlways === void 0 ? false : _showAlways, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(expanded), isExpanded = ref[0], setIsExpanded = ref[1];
    var id = (0,react__WEBPACK_IMPORTED_MODULE_2__.useId)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setIsExpanded(expanded);
    }, [
        expanded
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(QuestionWrapper, {
        svg: isExpanded ? _components_svgs_SvgarrowsCollapse__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z : _components_svgs_SvgarrowsExpand__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                role: "button",
                onClick: function() {
                    return setIsExpanded(!isExpanded);
                },
                children: question
            }),
            showAlways && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ui_SafeHtmlDiv__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                html: children
            }),
            !showAlways && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ui_Reveal__WEBPACK_IMPORTED_MODULE_4__/* .Reveal */ .U, {
                id: id,
                role: "region",
                open: isExpanded || showAlways,
                initiallyOpen: isExpanded || showAlways,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ui_SafeHtmlDiv__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    html: children
                })
            })
        ]
    });
};


/***/ }),

/***/ 503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tt": function() { return /* binding */ Scroller; },
/* harmony export */   "__": function() { return /* binding */ Label; },
/* harmony export */   "h_": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  // ul, li reset\n  padding: 0;\n  margin: 0;\n  & li {\n    margin: 0;\n    padding: 0;\n  }\n\n  ",
        "\n\n  \n  grid-template-columns: repeat(",
        ", 1fr);\n\n  ",
        " {\n    grid-template-columns: repeat(",
        ", 1fr);\n  }  \n\n  ",
        "\n\n  font-size: 14px;\n  font-family: var(--font-family-narrow);\n\n  .svg {\n    min-height: 0.8em !important;\n    min-width: 0.8em !important;\n    max-height: 0.8em;\n    max-width: 0.8em;\n    position: relative;\n    top: 5px;\n    align-self: flex-start;\n  }\n\n\n\n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  font-weight: 700;\n  font-size: calc(var(--text-body-font-size-tool) * 0.9);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  transition: opacity 0.3s;\n  opacity: ",
        ";\n  ",
        "\n\n  @media print {\n    height: auto;\n    overflow: visible;\n    opacity: 1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Meta = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-7c022c6e-0"
})(_templateObject(), function(param) {
    var inline = param.inline;
    return inline ? "\n  display: flex;\n  gap: var(--size-3);\n  " : "\n  display: grid;\n  gap: var(--size-1);\n  ";
}, function(param) {
    var col = param.col;
    return col > 1 ? 2 : 1;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.mobileLandscape;
}, function(param) {
    var col = param.col;
    return col;
}, function(param) {
    var nowrap = param.nowrap;
    return nowrap ? "\n\n    li {\n      max-width: 90%;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n    li span {\n      max-height: 1.3em;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      width: 100%;\n      overflow: hidden;\n    }\n    }\n    " : "\n\n  ";
});
var Label = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-7c022c6e-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
});
var Scroller = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7c022c6e-2"
})(_templateObject2(), function(param) {
    var opacity = param.opacity;
    return opacity !== null && opacity !== void 0 ? opacity : 1;
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("styledScrollbar");
});


/***/ }),

/***/ 255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dn": function() { return /* binding */ EMPTY_GEOJSON; },
/* harmony export */   "fy": function() { return /* binding */ createQueryFromState; },
/* harmony export */   "zu": function() { return /* binding */ createCompareQueryFromState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);

var EMPTY_GEOJSON = {
    type: "FeatureCollection",
    features: []
};
var skipParam = function(key, skip) {
    return skip ? skip.includes(key) : false;
};
var createQueryFromState = function(state, additionalParams, skip) {
    var queryParams = [];
    if (typeof (state === null || state === void 0 ? void 0 : state.isSearchOpen) !== "undefined" && !skipParam("search", skip)) queryParams.push("search=".concat(state.isSearchOpen ? 1 : 0));
    if (typeof (state === null || state === void 0 ? void 0 : state.isFilterOpen) !== "undefined" && !skipParam("filter", skip)) queryParams.push("filter=".concat(state.isFilterOpen ? 1 : 0));
    if (state.isSearchOpen) {
        if (!skipParam("keyword", skip)) queryParams.push("keyword=".concat(state.keyword));
    } else {
        if ((state === null || state === void 0 ? void 0 : state.terms) && Object.keys(state.terms).length && !skipParam("term", skip)) {
            queryParams.push("term=".concat(Object.keys(state.terms).sort().join(",")));
        }
        if ((state === null || state === void 0 ? void 0 : state.regions) && Object.keys(state.regions).length && !skipParam("regions", skip)) {
            queryParams.push("regions=".concat(Object.keys(state.regions).sort().join(",")));
        }
        if ((state === null || state === void 0 ? void 0 : state.countries) && Object.keys(state.countries).length && !skipParam("countries", skip)) {
            queryParams.push("countries=".concat(Object.keys(state.countries).sort().join(",")));
        }
        if ((state === null || state === void 0 ? void 0 : state.license) && Object.keys(state.license).length && !skipParam("license", skip)) {
            queryParams.push("license=".concat(Object.keys(state.license).sort().join(",")));
        }
        if ((state === null || state === void 0 ? void 0 : state.genderRatio) && Object.keys(state.genderRatio).length && !skipParam("genderRatio", skip)) {
            queryParams.push("genderRatio=".concat(Object.keys(state.genderRatio).sort().join(",")));
        }
        if ((state === null || state === void 0 ? void 0 : state.dateFrom) && (state === null || state === void 0 ? void 0 : state.dateUntil) && !skipParam("dateFrom", skip) && !skipParam("dateUntil", skip)) {
            queryParams.push("dateFrom=".concat(state === null || state === void 0 ? void 0 : state.dateFrom));
            queryParams.push("dateUntil=".concat(state === null || state === void 0 ? void 0 : state.dateUntil));
        }
    }
    if (additionalParams) {
        for(var param in additionalParams){
            queryParams.push("".concat(param, "=").concat(additionalParams[param]));
        }
    }
    return queryParams.length > 0 ? "?".concat(queryParams.join("&")) : "";
};
var createCompareQueryFromState = function(state, additionalParams, skip) {
    return createQueryFromState(state, additionalParams, [
        "empty",
        "filter",
        "keyword",
        "search", 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Array.isArray(skip) ? skip : [])));
};


/***/ }),

/***/ 8656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QL": function() { return /* binding */ useToolStateFilterState; },
/* harmony export */   "cH": function() { return /* binding */ useToolStateStoreActions; },
/* harmony export */   "e1": function() { return /* binding */ useToolStateMapState; },
/* harmony export */   "wk": function() { return /* binding */ useToolStateSettingsState; },
/* harmony export */   "ww": function() { return /* binding */ defaultCompareQueryString; }
/* harmony export */ });
/* unused harmony exports defaultToolState, quickClone, getToolStateDefaultState, useToolStateStore */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9815);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4529);
/* harmony import */ var _map_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(255);







var defaultToolState = {
    map: {
        loadGeoJson: false,
        geoJson: null,
        ready: false,
        mapController: null,
        hideIntro: false,
        totalInViewCount: 0,
        filteredInViewCount: 0
    },
    filter: {
        filteredCount: 0,
        totalCount: 0,
        filteredIds: null,
        filterQueryString: "",
        isFetchingFilteredIds: false,
        isDrawerOpen: false,
        quickViewProjectId: null,
        isFilterOpen: false,
        isSearchOpen: false,
        keyword: "",
        license: {},
        dateFrom: null,
        dateUntil: null,
        genderRatio: {},
        terms: {},
        countries: {},
        regions: {},
        s: null
    },
    settings: {
        styleUrl: "",
        countries: [],
        regions: [],
        funding: null,
        industrialSector: null,
        useOfAi: null,
        isProjectOpenSource: null,
        license: [
            {
                id: "os",
                name: "Open source"
            },
            {
                id: "cs",
                name: "Closed source"
            }, 
        ],
        genderRatio: [
            {
                id: "lt50",
                name: "< 50% (female/diverse)"
            },
            {
                id: "gte50",
                name: ">= 50% (female/diverse)"
            }, 
        ]
    }
};
var quickClone = function(obj) {
    if (!obj) return obj;
    if (Array.isArray(obj)) return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(obj);
    if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(obj, Object)) return obj;
    return Object.keys(obj).reduce(function(carry, key) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, carry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, key, quickClone(obj[key])));
    }, {});
};
var getToolStateDefaultState = function() {
    return quickClone(defaultToolState);
};
var useToolStateStore = (0,zustand__WEBPACK_IMPORTED_MODULE_6__/* .create */ .Ue)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, getToolStateDefaultState()), {
        getState: function() {
            return get();
        },
        getDefaultState: function() {
            return getToolStateDefaultState();
        },
        getFilterState: function() {
            return get().filter;
        },
        setFilterState: function(state) {
            return set(function() {
                return {
                    filter: state
                };
            });
        },
        updateFilterState: function(state) {
            return set(function() {
                var newFilterState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, get().filter, state);
                if ((0,_map_utils__WEBPACK_IMPORTED_MODULE_0__/* .createCompareQueryFromState */ .zu)(newFilterState) === defaultCompareQueryString) newFilterState.filteredCount = newFilterState.totalCount;
                return {
                    filter: newFilterState
                };
            });
        },
        getMapState: function() {
            return get().map;
        },
        setMapState: function(state) {
            return set(function() {
                return {
                    map: state
                };
            });
        },
        updateMapState: function(state) {
            return set(function() {
                return {
                    map: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, get().map, state)
                };
            });
        },
        setSettingsState: function(state) {
            return set(function() {
                return {
                    settings: state
                };
            });
        },
        updateSettingsState: function(state) {
            return set(function() {
                return {
                    settings: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, get().settings, state)
                };
            });
        }
    });
});
var defaultCompareQueryString = (0,_map_utils__WEBPACK_IMPORTED_MODULE_0__/* .createCompareQueryFromState */ .zu)(defaultToolState.filter);
var useToolStateStoreActions = function() {
    return useToolStateStore(function(state) {
        return Object.keys(state).reduce(function(carry, key) {
            if (key.startsWith("get") || key.startsWith("set") || key.startsWith("update")) {
                carry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, carry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, key, state[key]));
            }
            return carry;
        }, {});
    });
};
var useToolStateFilterState = function() {
    return useToolStateStore(function(state) {
        return state.filter;
    });
};
var useToolStateMapState = function() {
    return useToolStateStore(function(state) {
        return state.map;
    });
};
var useToolStateSettingsState = function() {
    return useToolStateStore(function(state) {
        return state.settings;
    });
};


/***/ }),

/***/ 19:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ IconButtonPrint; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _shared_ui_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7205);



var IconButtonPrint = function(param) {
    var spaceBefore = param.spaceBefore;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_ui_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
        type: "print",
        "aria-label": "Print page",
        className: "print",
        spaceBefore: spaceBefore,
        onClick: function() {
            if (false) {}
            window.print();
        }
    });
};


/***/ }),

/***/ 1663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Reveal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9521);
/* harmony import */ var _hooks_useIsMounted__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9039);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_4__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  height: ",
        ";\n  transition: ",
        ";\n  width: 100%;\n  overflow: ",
        ";\n\n  @media print { \n    height: auto;\n    position: static;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  top: ",
        ";\n  bottom: ",
        ";\n  left: 0;\n  width: 100%;\n\n  @media print { \n    position: static;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Container = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7eee1127-0"
})(_templateObject(), function(param) {
    var active = param.active;
    return active ? "relative" : "static";
}, function(param) {
    var height = param.height, active = param.active;
    return active ? height !== null && height !== void 0 ? height : 0 : "auto";
}, function(param) {
    var active = param.active, duration = param.duration;
    return active ? "height ".concat(duration, "ms") : "none";
}, function(param) {
    var offset = param.offset;
    return offset;
});
var Payload = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7eee1127-1"
})(_templateObject1(), function(param) {
    var active = param.active;
    return active ? "absolute" : "static";
}, function(param) {
    var position = param.position;
    return position === "top" ? "0" : "auto";
}, function(param) {
    var position = param.position;
    return position === "bottom" ? "0" : "auto";
});
var Reveal = function(param) {
    var id = param.id, _role = param.role, role = _role === void 0 ? "region" : _role, children = param.children, open = param.open, _duration = param.duration, duration = _duration === void 0 ? 300 : _duration, initiallyOpen = param.initiallyOpen, _active = param.active, active = _active === void 0 ? true : _active, _position = param.position, position = _position === void 0 ? "bottom" : _position;
    var isMounted = (0,_hooks_useIsMounted__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var offsetTimoutRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var payloadRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initiallyOpen ? "auto" : "0px"), height = ref[0], setHeight = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(open ? "visible" : "hidden"), offset = ref1[0], setOffset = ref1[1];
    var toggleOffset = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (!isMounted) return;
        setOffset(open ? "visible" : "hidden");
    }, [
        isMounted,
        open
    ]);
    var onResize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (open) {
            var ref;
            var ref1;
            setHeight("".concat((ref1 = payloadRef === null || payloadRef === void 0 ? void 0 : (ref = payloadRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) !== null && ref1 !== void 0 ? ref1 : 0, "px"));
        } else {
            setHeight("0px");
        }
    }, [
        open
    ]);
    var onResizeDebounced = lodash_debounce__WEBPACK_IMPORTED_MODULE_4___default()(onResize, 100);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (false) {}
        window.addEventListener("resize", onResizeDebounced);
        onResize();
        return function() {
            window.removeEventListener("resize", onResizeDebounced);
        };
    }, [
        onResize,
        onResizeDebounced
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (false) {}
        setOffset("hidden");
        onResize();
        if (offsetTimoutRef.current) clearTimeout(offsetTimoutRef.current);
        offsetTimoutRef.current = setTimeout(toggleOffset, duration);
    }, [
        open,
        duration,
        toggleOffset,
        onResize
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        id: id,
        height: height,
        duration: duration,
        active: active,
        offset: offset,
        "aria-hidden": !open,
        role: role,
        tabIndex: !open ? -1 : undefined,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Payload, {
            ref: payloadRef,
            active: active,
            position: position,
            children: children
        })
    });
};


/***/ }),

/***/ 3427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export SafeHtmlDiv */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_sanitize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2938);



var SafeHtmlDiv = function(param) {
    var html = param.html, style = param.style;
    if (typeof html !== "string") return html;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: style,
        dangerouslySetInnerHTML: {
            __html: (0,_utils_sanitize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(html)
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafeHtmlDiv);


/***/ })

}]);